var _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyMyCertificates(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.45,42.76a19.94,19.94,0,0,1,4.89-2.13l1-4.84,8.18-.15,1.18,4.81a19.91,19.91,0,0,1,5,1.95l4.13-2.71,5.89,5.68-2.57,4.23a19.78,19.78,0,0,1,2.13,4.89l4.84,1,.15,8.18-4.81,1.18a20,20,0,0,1-1.95,5L162.2,74l-5.68,5.89-4.23-2.57a19.94,19.94,0,0,1-4.89,2.13l-1,4.84-8.18.14L137,79.59a19.69,19.69,0,0,1-5-2l-4.14,2.71L122,74.66l2.57-4.22a19.85,19.85,0,0,1-2.13-4.9l-4.84-1-.15-8.18,4.81-1.18a19.91,19.91,0,0,1,2-5l-2.71-4.13,5.68-5.89,4.23,2.57Zm4.36,10.89a8.78,8.78,0,1,0,12.42-.21A8.79,8.79,0,0,0,135.81,53.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,359a20,20,0,0,1,4.89-2.12l1-4.85,8.18-.14,1.17,4.8a20.33,20.33,0,0,1,5,2l4.13-2.71,5.89,5.68-2.56,4.23a20,20,0,0,1,2.12,4.89l4.85,1,.14,8.18-4.8,1.18a20.42,20.42,0,0,1-2,5l2.71,4.13L64,396.06l-4.23-2.56a20.13,20.13,0,0,1-4.89,2.12l-1,4.85-8.18.14-1.18-4.8a20.42,20.42,0,0,1-5-2l-4.14,2.71-5.88-5.68,2.56-4.23A20.38,20.38,0,0,1,30,381.76l-4.84-1L25,372.57l4.8-1.18a20.39,20.39,0,0,1,1.95-5L29,362.29l5.69-5.88L39,359Zm4.36,10.9a8.78,8.78,0,1,0,12.41-.22A8.77,8.77,0,0,0,43.31,369.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.77,46a28.81,28.81,0,0,1,7.1-3.09l1.46-7,11.87-.21,1.71,7a28.76,28.76,0,0,1,7.2,2.83l6-3.93,8.54,8.24-3.72,6.14A28.81,28.81,0,0,1,103,63l7,1.46.21,11.87-7,1.71a29.3,29.3,0,0,1-2.83,7.2l3.93,6-8.25,8.54L90,96.07a28.77,28.77,0,0,1-7.1,3.08l-1.46,7-11.87.21-1.71-7a29.15,29.15,0,0,1-7.2-2.83l-6,3.93-8.54-8.25,3.72-6.13A29.14,29.14,0,0,1,46.75,79l-7-1.46-.21-11.87,7-1.71a29.15,29.15,0,0,1,2.83-7.2l-3.93-6,8.25-8.54L59.77,46ZM66.1,61.79a12.73,12.73,0,1,0,18-.32A12.73,12.73,0,0,0,66.1,61.79Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.71,309.24c-8.73,4.52-15.42,12.31-20.23,20.88s-7.92,18-11,27.3l-2.68,48.15c10.15-17.28,18.3-37.58,20.5-57.5l-6.76-.6c4.53-.69,8.34-4,10.76-7.87s3.66-8.38,4.88-12.8L452.94,328A30.56,30.56,0,0,0,465.71,309.24Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.3,416.85s-22-26.38-21.78-51.56h8.9s-9.67-6.36-8.9-9.92,1-17,1-17l8.14,2s-6.11-3.05-6.87-7.89,1.78-27.21,1.78-27.21,9.92,10.43,13,21.11,11.06,23.15,8.71,55.71S430.3,416.85,430.3,416.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.48,419.34s23.87-15.91,29.18-36.21l-7.16-1.95s9.17-3,9.33-6,2.91-13.93,2.91-13.93l-7-.14s5.58-1.12,7.25-4.84S480.52,334,480.52,334s-10.26,6.21-15,14.13-14,16.19-19.19,42.88S441.48,419.34,441.48,419.34Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.61,328.26a.91.91,0,0,1,.08.27l.2.81.71,3.13c.31,1.36.67,3,1,5s.86,4.15,1.31,6.6c1,4.89,2,10.74,3,17.24s2,13.69,2.87,21.23,1.53,14.77,2.05,21.34.84,12.49,1,17.47c.12,2.49.18,4.74.24,6.72s.09,3.68.1,5.07,0,2.44,0,3.21c0,.34,0,.61,0,.83a1.64,1.64,0,0,1,0,.29,1.11,1.11,0,0,1,0-.29c0-.22,0-.49-.05-.83q0-1.15-.12-3.21c0-1.39-.1-3.09-.19-5.06s-.17-4.23-.32-6.71c-.23-5-.63-10.89-1.14-17.45s-1.23-13.77-2.09-21.32-1.86-14.71-2.83-21.22-2-12.35-2.86-17.25c-.43-2.45-.86-4.66-1.23-6.6s-.69-3.62-1-5-.46-2.39-.61-3.15l-.15-.82A1,1,0,0,1,418.61,328.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.25,433s-20.17-22.88-26.44-36.71l4.73-2c-3.42.56-6.93-.91-9.59-3.15a36,36,0,0,1-6.52-8.08l6.22-1.05a23.12,23.12,0,0,1-13.6-10.54c7.35,1.21,14,5.25,19.47,10.29a97,97,0,0,1,11.81,13.68,46.28,46.28,0,0,1,4.58,7.53C421.3,410,427.26,424.6,427.25,433Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471,347.3a.88.88,0,0,1-.08.23c-.09.18-.19.4-.31.67-.3.62-.7,1.47-1.22,2.54-1.07,2.2-2.6,5.4-4.45,9.37-3.7,7.93-8.58,19-13.4,31.46s-8.65,23.94-11.25,32.3c-1.3,4.18-2.32,7.57-3,9.92-.34,1.14-.61,2-.81,2.7-.09.29-.16.52-.22.7a1.78,1.78,0,0,1-.09.24.66.66,0,0,1,0-.25c0-.19.1-.43.17-.71.18-.67.41-1.58.72-2.73.62-2.37,1.59-5.78,2.85-10,2.51-8.39,6.29-19.9,11.11-32.38s9.77-23.53,13.56-31.43c1.89-3.95,3.47-7.12,4.6-9.3l1.31-2.5.35-.64A1.37,1.37,0,0,1,471,347.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429,442.81a9.54,9.54,0,0,1-.32-1.63c-.16-1.06-.43-2.58-.8-4.45a92.31,92.31,0,0,0-4.09-14.3A93.52,93.52,0,0,0,417.37,409c-1-1.65-1.76-3-2.34-3.87a9.86,9.86,0,0,1-.84-1.43,11,11,0,0,1,1,1.32c.63.87,1.48,2.16,2.48,3.79a81,81,0,0,1,10.52,27.86c.33,1.89.54,3.42.64,4.49A11.18,11.18,0,0,1,429,442.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.43,
    y: 437.43,
    width: 44.14,
    height: 9,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.63 446.43 420.41 476.72 447.08 476.72 451.53 446.43 415.63 446.43",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.86,446.43c0,.14-8.35.26-18.65.26s-18.65-.12-18.65-.26,8.35-.26,18.65-.26S452.86,446.29,452.86,446.43Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.71,
    y: 46.65,
    width: 21.46,
    height: 7.99,
    transform: "translate(196.37 367.6) rotate(-72.81)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.65,
    y: 46.02,
    width: 21.46,
    height: 7.99,
    transform: "translate(195.53 365.18) rotate(-72.81)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.54,45.19a1.8,1.8,0,1,1-1.19-2.25A1.79,1.79,0,0,1,348.54,45.19Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.46,44.66a6.86,6.86,0,0,1-1.4,1.26A7.13,7.13,0,0,1,350.49,47a7,7,0,0,1,1.41-1.27A6.77,6.77,0,0,1,353.46,44.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.76,46.92a6.43,6.43,0,0,1-1.4,1.27,6.48,6.48,0,0,1-1.57,1.05,7.22,7.22,0,0,1,1.4-1.26A7.39,7.39,0,0,1,352.76,46.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.06,49.19a6.74,6.74,0,0,1-1.4,1.27,6.48,6.48,0,0,1-1.57,1,6.55,6.55,0,0,1,1.4-1.26A6.72,6.72,0,0,1,352.06,49.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.36,51.46A7.33,7.33,0,0,1,350,52.73a6.77,6.77,0,0,1-1.56,1.05,6.55,6.55,0,0,1,1.4-1.26A6.36,6.36,0,0,1,351.36,51.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.66,53.73A7.11,7.11,0,0,1,349.25,55a7,7,0,0,1-1.56,1.06,12.84,12.84,0,0,1,3-2.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350,56a6.86,6.86,0,0,1-1.4,1.26A6.72,6.72,0,0,1,347,58.32a7,7,0,0,1,1.41-1.27A6.77,6.77,0,0,1,350,56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.25,58.26a6.43,6.43,0,0,1-1.4,1.27,7.13,7.13,0,0,1-1.57,1.06,7,7,0,0,1,1.41-1.27A7.48,7.48,0,0,1,349.25,58.26Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.06,42.65a6.55,6.55,0,0,1-1.4,1.26A6.72,6.72,0,0,1,351.09,45a6.74,6.74,0,0,1,1.4-1.27A6.7,6.7,0,0,1,354.06,42.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.62,41.32c0,.06-.31.42-.8.8s-.91.64-1,.58.31-.41.8-.79S353.57,41.27,353.62,41.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.44,61.66l6-18s4.27.47,9.56-3.9c3.5-2.9,3.82-7,4.77-8.46.58-.89,2.81,0,3.78.44a4.16,4.16,0,0,1,2.53,3.14c.36,3.18-3.42,9.33-3.42,9.33s-1.18,1.13.73,1.72l6.8,2.11a3.89,3.89,0,0,1,2.16,1.61,2.88,2.88,0,0,1,.25,2.71c-1,2.53-2.73,3.27-2.9,3.81s.29,1.73-.74,3.13-1.33,1.15-1.56,1.9a12.87,12.87,0,0,1-1.79,3.63,6,6,0,0,1-1.55,1.39A8.52,8.52,0,0,1,375.4,70c-1.56,1.51-6.43,1.33-8-.09-.74-.67-4.49-2.89-6.25-4S354.55,61.34,352.44,61.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.94,61.11l5.67-18.32s4.27.47,9.56-3.91a31.74,31.74,0,0,0,6.43-6.94,2.18,2.18,0,0,1,2.69-.83A3.34,3.34,0,0,1,376.44,34c.36,3.17-3.61,9.38-3.61,9.38s-1.18,1.13.73,1.72l6.8,2.11a3.89,3.89,0,0,1,2.16,1.61,2.88,2.88,0,0,1,.25,2.71c-1,2.53-2.73,3.26-2.9,3.81s.29,1.73-.74,3.13-1.33,1.15-1.56,1.9A12.87,12.87,0,0,1,375.78,64a5.77,5.77,0,0,1-1.55,1.38,10,10,0,0,1-1.68,3.74c-1.12,1.22-4.22,1.08-5.17.79S360,66.1,358.28,65,352.05,60.8,349.94,61.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.44,40.76a9.13,9.13,0,0,1-2.1,1.34,8.9,8.9,0,0,1-2.29,1,17.58,17.58,0,0,1,2.17-1.21A17.25,17.25,0,0,1,377.44,40.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.57,38.42a6.25,6.25,0,0,1-2,1.15,10.9,10.9,0,0,1-2.13.78,8.86,8.86,0,0,1,2-1C377.64,38.84,378.53,38.36,378.57,38.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.06,36.16a3.84,3.84,0,0,1-1.61.91,10.15,10.15,0,0,1-1.76.54,4.86,4.86,0,0,1,1.67-.79C378.31,36.5,379,36.09,379.06,36.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.88,34.08a3.53,3.53,0,0,1-1.18.66,3.59,3.59,0,0,1-1.29.41,3.53,3.53,0,0,1,1.18-.66A3.59,3.59,0,0,1,378.88,34.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.84,32.57c0,.07-.31.23-.73.35s-.77.16-.8.09.3-.22.73-.35S377.82,32.5,377.84,32.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,43.83a4.2,4.2,0,0,1-1.26.69,3.85,3.85,0,0,1-1.36.44,3.75,3.75,0,0,1,1.26-.69A3.85,3.85,0,0,1,375.91,43.83Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385,53.64a13.4,13.4,0,0,1-2.49.91,12.32,12.32,0,0,1-2.56.65,13.62,13.62,0,0,1,2.48-.91A13.13,13.13,0,0,1,385,53.64Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.86,50.5a9.31,9.31,0,0,1-3,.94,4.74,4.74,0,0,1,1.46-.6A4.79,4.79,0,0,1,385.86,50.5Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.59,57.76a9.76,9.76,0,0,1-1.85.62,10,10,0,0,1-1.88.53,5.87,5.87,0,0,1,1.8-.78A5.69,5.69,0,0,1,382.59,57.76Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.5,61a14.45,14.45,0,0,1-3.64,1.3,7.13,7.13,0,0,1,1.78-.78A6.91,6.91,0,0,1,380.5,61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.42,64.92a7.57,7.57,0,0,1-2.06.93,7.3,7.3,0,0,1-2.21.49,16.36,16.36,0,0,1,2.12-.75A14.5,14.5,0,0,1,378.42,64.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.46,68.16a9.52,9.52,0,0,1-2.42,1,9.17,9.17,0,0,1-2.56.61A23.14,23.14,0,0,1,374,69,20.72,20.72,0,0,1,376.46,68.16Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.74,
    y: 150.8,
    width: 6.93,
    height: 18.63,
    transform: "translate(-14.39 46.01) rotate(-6.01)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.88,
    y: 150.99,
    width: 6.93,
    height: 18.63,
    transform: "translate(-14.42 45.82) rotate(-6.01)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.22,155.39a1.56,1.56,0,1,1-1.72-1.4A1.57,1.57,0,0,1,430.22,155.39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434,153.27a5.45,5.45,0,0,1-.69,1.49,5.91,5.91,0,0,1-.88,1.38,5.75,5.75,0,0,1,.68-1.49A6,6,0,0,1,434,153.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.18,155.32a6.28,6.28,0,0,1-.69,1.49,5.75,5.75,0,0,1-.89,1.38,5.6,5.6,0,0,1,.69-1.49A5.66,5.66,0,0,1,434.18,155.32Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.39,157.37a5.59,5.59,0,0,1-.68,1.49,6.13,6.13,0,0,1-.89,1.38,5.75,5.75,0,0,1,.68-1.49A6.43,6.43,0,0,1,434.39,157.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.61,159.42a6,6,0,0,1-.69,1.49,5.42,5.42,0,0,1-.89,1.38,6,6,0,0,1,.69-1.49A5.66,5.66,0,0,1,434.61,159.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.82,161.47a5.75,5.75,0,0,1-.68,1.49,6.43,6.43,0,0,1-.89,1.38,5.75,5.75,0,0,1,.68-1.49A6.43,6.43,0,0,1,434.82,161.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435,163.52a6,6,0,0,1-.69,1.49,5.66,5.66,0,0,1-.89,1.38,6,6,0,0,1,.69-1.49A5.66,5.66,0,0,1,435,163.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.25,165.57a5.75,5.75,0,0,1-.68,1.49,6,6,0,0,1-.89,1.38,5.6,5.6,0,0,1,.69-1.49A6.19,6.19,0,0,1,435.25,165.57Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.75,151.47a5.6,5.6,0,0,1-.69,1.49,6.19,6.19,0,0,1-.88,1.38,5.75,5.75,0,0,1,.68-1.49A6,6,0,0,1,433.75,151.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433,150.56a2.26,2.26,0,0,1-.37.91c-.26.47-.51.82-.57.79a2.24,2.24,0,0,1,.37-.9C432.64,150.89,432.89,150.53,433,150.56Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439,167.19l-1.35-16.41s3.57-1.09,6.3-6.39c1.8-3.5.64-6.89.9-8.37.16-.91,2.26-1,3.18-.94a3.6,3.6,0,0,1,3.09,1.64c1.37,2.41.46,8.61.46,8.61s-.55,1.31,1.17,1.12l6.15-.64a3.31,3.31,0,0,1,2.27.55,2.51,2.51,0,0,1,1.13,2.08c.06,2.36-1.06,3.53-1,4s.82,1.29.47,2.76-.66,1.37-.59,2.05a11.13,11.13,0,0,1-.19,3.5,5,5,0,0,1-.76,1.64,7.45,7.45,0,0,1-.06,3.55c-.73,1.74-4.68,3.26-6.43,2.67-.82-.27-4.58-.76-6.34-1S440.54,166.22,439,167.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.78,167.61,435,151.05s3.57-1.09,6.3-6.38a27.66,27.66,0,0,0,2.76-7.74,1.89,1.89,0,0,1,1.86-1.58,2.86,2.86,0,0,1,2.68,1.53c1.38,2.41.33,8.73.33,8.73s-.55,1.3,1.18,1.12l6.14-.65a3.36,3.36,0,0,1,2.27.55,2.51,2.51,0,0,1,1.13,2.08c.06,2.36-1.06,3.53-1,4s.82,1.28.48,2.75-.67,1.37-.59,2a11,11,0,0,1-.2,3.51,5,5,0,0,1-.76,1.63,8.58,8.58,0,0,1-.06,3.56c-.48,1.35-3,2.3-3.85,2.39s-7.15-.49-8.92-.74S438.35,166.64,436.78,167.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.76,142a8.09,8.09,0,0,1-1.22,1.78,7.57,7.57,0,0,1-1.49,1.56,14.41,14.41,0,0,1,1.31-1.7A14.18,14.18,0,0,1,451.76,142Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.86,139.72a5.65,5.65,0,0,1-1.17,1.58,8.74,8.74,0,0,1-1.43,1.35,7.78,7.78,0,0,1,1.26-1.51C451.26,140.37,451.81,139.68,451.86,139.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.48,137.74a3.28,3.28,0,0,1-1,1.28,8.86,8.86,0,0,1-1.22,1,4.12,4.12,0,0,1,1.06-1.2C451,138.27,451.42,137.7,451.48,137.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.63,136.15a3.35,3.35,0,0,1-.72.93,3.54,3.54,0,0,1-.89.77s.27-.46.72-.93S450.58,136.1,450.63,136.15Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.28,135.3s-.17.28-.46.52-.57.4-.61.35.16-.28.46-.53S449.24,135.24,449.28,135.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.59,144.94a3.73,3.73,0,0,1-.77,1,3.81,3.81,0,0,1-.93.82c-.05-.05.29-.48.76-1S451.54,144.89,451.59,144.94Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.2,149.66a11.78,11.78,0,0,1-1.67,1.57,11.91,11.91,0,0,1-1.82,1.4,10.56,10.56,0,0,1,1.67-1.57A11.38,11.38,0,0,1,462.2,149.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.81,146.86a8.28,8.28,0,0,1-2.08,1.78,4.13,4.13,0,0,1,1-1A4.22,4.22,0,0,1,461.81,146.86Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.68,153.77a8.09,8.09,0,0,1-1.26,1.13A8.53,8.53,0,0,1,459.1,156a7.7,7.7,0,0,1,2.58-2.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.12,157.06a6.42,6.42,0,0,1-1.15,1.23,5.76,5.76,0,0,1-1.31,1.05,6.55,6.55,0,0,1,1.15-1.22A6.27,6.27,0,0,1,461.12,157.06Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.8,160.91a6,6,0,0,1-1.33,1.44,6.13,6.13,0,0,1-1.59,1.16,12.58,12.58,0,0,1,1.44-1.33A12,12,0,0,1,460.8,160.91Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.35,164.17a9,9,0,0,1-1.57,1.66,8.59,8.59,0,0,1-1.84,1.37,20.67,20.67,0,0,1,1.68-1.55A16,16,0,0,1,460.35,164.17Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.92,476.28c0,.15-98.47.26-219.91.26s-219.93-.11-219.93-.26S128.53,476,250,476,469.92,476.14,469.92,476.28Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.72,120.86l-8.64-28.57S425,89,427.8,78.57c1.87-6.89-1.48-12.46-1.58-15.19-.06-1.66,3.63-2.54,5.27-2.87a6.5,6.5,0,0,1,6.09,1.73c3.36,3.75,4.1,15.09,4.1,15.09s-.48,2.52,2.51,1.54l10.65-3.48a6,6,0,0,1,4.22.11,4.55,4.55,0,0,1,2.8,3.25c1,4.16-.54,6.67-.26,7.52s1.94,2,1.89,4.69-.65,2.69-.26,3.87a20.29,20.29,0,0,1,1,6.28,9.15,9.15,0,0,1-.72,3.19s1.57,3.73,1.24,6.32-4.43,5.23-5.92,5.72-12.85,1.84-16.08,2.08S430.14,118.53,427.72,120.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,122.43l-9.39-28.68s5.91-3.29,8.72-13.71a50.18,50.18,0,0,0,1.94-14.77,3.42,3.42,0,0,1,2.69-3.5,5.22,5.22,0,0,1,5.35,1.7c3.35,3.74,3.9,15.33,3.9,15.33s-.47,2.51,2.51,1.53l10.65-3.48a6,6,0,0,1,4.23.11,4.54,4.54,0,0,1,2.79,3.25c1,4.16-.54,6.67-.26,7.52s1.95,2,1.9,4.69-.66,2.7-.27,3.87a20.05,20.05,0,0,1,1,6.28,9.15,9.15,0,0,1-.72,3.19s1.57,3.73,1.24,6.32-4.42,5.23-5.92,5.72-12.85,1.85-16.08,2.08S426.44,120.1,424,122.43Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.16,65a20.7,20.7,0,0,1-3-1,20.7,20.7,0,0,1-2.86-1.2A39.09,39.09,0,0,1,419.16,65Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.64,60.3a8.18,8.18,0,0,1-1.18-.79c-.71-.52-1.66-1.27-2.68-2.13s-1.91-1.7-2.54-2.31a6.71,6.71,0,0,1-1-1,11,11,0,0,1,1.08.92c.65.58,1.56,1.38,2.58,2.25s1.95,1.63,2.63,2.18A9.12,9.12,0,0,1,422.64,60.3Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.08,47.57a40,40,0,0,1,1.46,4.1,41.88,41.88,0,0,1,1.25,4.18,41.08,41.08,0,0,1-1.47-4.11A39.6,39.6,0,0,1,423.08,47.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.79,50.9a16.76,16.76,0,0,1-1.18,2.6,17.8,17.8,0,0,1-1.4,2.5,19.41,19.41,0,0,1,1.19-2.6A18.42,18.42,0,0,1,434.79,50.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.44,55a11,11,0,0,1-.94,2.12,11.46,11.46,0,0,1-1.16,2,12.4,12.4,0,0,1,1-2.12A11.35,11.35,0,0,1,439.44,55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.8,71.28a5.64,5.64,0,0,1-.4,1.08c-.27.65-.68,1.54-1.16,2.51s-1,1.81-1.33,2.42a4.91,4.91,0,0,1-.64.95,6.84,6.84,0,0,1,.49-1L439,74.76c.46-.92.87-1.76,1.22-2.47A6.8,6.8,0,0,1,440.8,71.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.11,67.26a4,4,0,0,1-.36,1,23.21,23.21,0,0,1-1.18,2.23c-.51.84-1,1.58-1.34,2.12a5.3,5.3,0,0,1-.6.85,21.92,21.92,0,0,1,1.74-3.09c.5-.84.93-1.61,1.23-2.18A6,6,0,0,1,440.11,67.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.69,63.9a2.66,2.66,0,0,1-.28.8,11.45,11.45,0,0,1-1,1.79c-.95,1.28-1.64,2.37-1.69,2.34a11,11,0,0,1,1.5-2.48C438.11,65.06,438.62,63.87,438.69,63.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.57,61.4a9.34,9.34,0,0,1-1,1.87,9.87,9.87,0,0,1-1.2,1.75,9.34,9.34,0,0,1,1-1.87A10.36,10.36,0,0,1,436.57,61.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.85,60.41a3.59,3.59,0,0,1-.68,1.05,3.75,3.75,0,0,1-.87.91,3.45,3.45,0,0,1,.68-1.06C433.42,60.77,433.8,60.37,433.85,60.41Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.62,76.61a10.4,10.4,0,0,1-1.07,2,11.41,11.41,0,0,1-1.26,1.86,10.4,10.4,0,0,1,1.07-2A11.41,11.41,0,0,1,441.62,76.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.22,80.93a37.64,37.64,0,0,1-2.43,3.37,34.9,34.9,0,0,1-2.63,3.24,37.55,37.55,0,0,1,2.44-3.38A38.79,38.79,0,0,1,462.22,80.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.46,76.13a13.44,13.44,0,0,1-1.41,2,13,13,0,0,1-1.6,1.9,13.11,13.11,0,0,1,1.42-2A13.38,13.38,0,0,1,460.46,76.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.87,88.42c.05,0-.85,1.08-1.88,2.42s-1.8,2.48-1.85,2.45a2.93,2.93,0,0,1,.42-.8,21.25,21.25,0,0,1,1.25-1.79c.51-.67,1-1.25,1.4-1.66A3.65,3.65,0,0,1,462.87,88.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.37,94.12a22.87,22.87,0,0,1-1.77,2.73,22.48,22.48,0,0,1-2,2.59,23.84,23.84,0,0,1,1.77-2.73A21.21,21.21,0,0,1,463.37,94.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,101.4a4.82,4.82,0,0,1-.49.92c-.33.56-.81,1.3-1.39,2.09a25.08,25.08,0,0,1-1.57,2,4.25,4.25,0,0,1-.73.74,4.89,4.89,0,0,1,.6-.84c.4-.51.93-1.21,1.51-2s1.08-1.52,1.45-2A4.84,4.84,0,0,1,464,101.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.46,107.35a5.77,5.77,0,0,1-.58,1.06c-.39.64-1,1.5-1.64,2.42s-1.33,1.74-1.81,2.3a5,5,0,0,1-.85.88,7.9,7.9,0,0,1,.72-1c.45-.59,1.07-1.41,1.75-2.33s1.27-1.76,1.69-2.38A7.06,7.06,0,0,1,464.46,107.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.94,62.73a11.61,11.61,0,0,1-2.25.61,11.44,11.44,0,0,1,2.18-.84,11.61,11.61,0,0,1,2.25-.61A12.7,12.7,0,0,1,446.94,62.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.32,
    y: 94.68,
    width: 11.53,
    height: 30.99,
    transform: "translate(-13.82 133.76) rotate(-18.14)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.36,
    y: 95.65,
    width: 11.53,
    height: 30.99,
    transform: "translate(-14.27 132.89) rotate(-18.14)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.83,102.83a2.6,2.6,0,1,1-3.28-1.66A2.61,2.61,0,0,1,408.83,102.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.17,98.09a14.59,14.59,0,0,1-.66,2.64,16,16,0,0,1-.89,2.57,14.59,14.59,0,0,1,.66-2.64A16,16,0,0,1,414.17,98.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.24,101.35a16.65,16.65,0,0,1-.67,2.64,16.44,16.44,0,0,1-.89,2.57,16.37,16.37,0,0,1,.67-2.64A16,16,0,0,1,415.24,101.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.31,104.6a16.37,16.37,0,0,1-.67,2.64,16.82,16.82,0,0,1-.89,2.58,16.37,16.37,0,0,1,.67-2.64A16.34,16.34,0,0,1,416.31,104.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,107.86a16.37,16.37,0,0,1-.67,2.64,16,16,0,0,1-.89,2.57,15.93,15.93,0,0,1,.66-2.64A15.41,15.41,0,0,1,417.38,107.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.44,111.12a15.68,15.68,0,0,1-.66,2.64,15.41,15.41,0,0,1-.9,2.57,16.37,16.37,0,0,1,.67-2.64A16,16,0,0,1,418.44,111.12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.51,114.38a16.65,16.65,0,0,1-.67,2.64,16,16,0,0,1-.89,2.57,16.37,16.37,0,0,1,.67-2.64A16,16,0,0,1,419.51,114.38Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.58,117.63a16.37,16.37,0,0,1-.67,2.64,16.34,16.34,0,0,1-.89,2.58,16.37,16.37,0,0,1,.67-2.64A16.82,16.82,0,0,1,420.58,117.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.2,95.22a15.68,15.68,0,0,1-.66,2.64,15.75,15.75,0,0,1-.9,2.58,16.37,16.37,0,0,1,.67-2.64A16.82,16.82,0,0,1,413.2,95.22Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.58,94a6,6,0,0,1-.35,1.58,5.44,5.44,0,0,1-.58,1.51,10.89,10.89,0,0,1,.93-3.09Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clipboard--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 117.94,
    y: 73.68,
    width: 265.77,
    height: 377.22,
    rx: 10.74,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,450.91l.82-.06a11.28,11.28,0,0,0,2.39-.46,11,11,0,0,0,3.51-1.91,10.7,10.7,0,0,0,3.23-4.44,10.37,10.37,0,0,0,.69-3.24c.06-1.17,0-2.42,0-3.72q0-3.91,0-8.54c0-6.18,0-13.3,0-21.31,0-32.08-.05-78.49-.08-135.83,0-28.67,0-60.08,0-93.79q0-25.29,0-52.26,0-13.47,0-27.32,0-6.93,0-13.94a10.46,10.46,0,0,0-8.16-9.9,15,15,0,0,0-3.49-.27H128.71a10.48,10.48,0,0,0-10.49,10c0,5.41,0,10.85,0,16.25v32.19q0,32,0,62.94c0,41.26,0,81.06,0,119s0,73.95,0,107.67v12.53c0,2.07,0,4.14,0,6.18a10.44,10.44,0,0,0,1.91,5.61,10.66,10.66,0,0,0,4.58,3.67,11.35,11.35,0,0,0,2.86.73c1,.08,2,.06,3,.07h11.85l45,0,135.82.08,36.92.05,9.6,0,3.28,0s-1.11,0-3.28,0l-9.6,0-36.92.05-135.82.08-45,0H130.5c-1,0-2,0-3-.07a11.67,11.67,0,0,1-3-.75,11.07,11.07,0,0,1-4.77-3.82,10.82,10.82,0,0,1-2-5.83c-.05-2.06,0-4.11,0-6.19V421.92c0-33.72,0-69.75,0-107.67s0-77.71,0-119q0-30.94,0-62.94V100.15c0-5.41,0-10.81,0-16.27a11,11,0,0,1,11-10.45h243.1a14.51,14.51,0,0,1,3.59.28,10.91,10.91,0,0,1,8.53,10.35q0,7,0,14v27.32q0,26.94,0,52.26c0,33.71,0,65.12,0,93.79,0,57.34-.06,103.75-.08,135.83,0,8,0,15.13,0,21.31q0,4.62,0,8.54c0,1.3,0,2.54,0,3.73a10.29,10.29,0,0,1-.72,3.27,10.87,10.87,0,0,1-3.27,4.47,10.48,10.48,0,0,1-5.95,2.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "143.15 441.54 366.01 440.32 368.57 397.26 361.74 371.3 141.13 405.77 143.15 441.54"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "317.89 74.45 322.96 89.49 322.96 96.85 317.24 96.85 317.89 74.45"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "129.58 89.08 129.58 435.6 371.65 435.6 371.65 373.63 371.65 89.08 129.58 89.08",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.58,89.08l242.07-.21h.21v.21c0,96.3,0,216.47.05,346.49v.29h-.26l-242.07,0h-.23v-.23c.14-204.6.23-344.41.23-346.52,0,2.11.1,141.92.24,346.52l-.24-.24,242.07,0-.26.26v0c0-130,0-250.19.05-346.49l.21.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,64.29H311.56a6.33,6.33,0,0,1,6.33,6.33v29.2a0,0,0,0,1,0,0H195.41a0,0,0,0,1,0,0V70.61A6.33,6.33,0,0,1,201.74,64.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.24 50.93 241.06 50.93 244.71 77.65 268.19 77.65 272.24 50.93",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,64.29c0,.14-23.9.26-53.37.26s-53.37-.12-53.37-.26S227.17,64,256.65,64,310,64.15,310,64.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.15,94.08c-.14,0-.26-5-.26-11.22s.12-11.22.26-11.22.26,5,.26,11.22S198.29,94.08,198.15,94.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.92,91.42c-.14,0-.25-4.56-.25-10.19s.11-10.19.25-10.19a98,98,0,0,1,.26,10.19A97.86,97.86,0,0,1,313.92,91.42Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308,96.15c0,.14-24.53.26-54.79.26s-54.78-.12-54.78-.26,24.52-.26,54.78-.26S308,96,308,96.15Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Checklist--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.41,205.18c0,.14-16.56.26-37,.26s-37-.12-37-.26,16.55-.26,37-.26S230.41,205,230.41,205.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,218.12c0,.14-43.21.26-96.5.26s-96.51-.12-96.51-.26,43.2-.26,96.51-.26S350.73,218,350.73,218.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,230c0,.14-43.21.26-96.5.26s-96.51-.12-96.51-.26,43.2-.26,96.51-.26S350.73,229.88,350.73,230Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,241.93c0,.15-43.21.27-96.5.27s-96.51-.12-96.51-.27,43.2-.26,96.51-.26S350.73,241.79,350.73,241.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,253.84c0,.15-43.21.26-96.5.26s-96.51-.11-96.51-.26,43.2-.26,96.51-.26S350.73,253.7,350.73,253.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.73,265.75c0,.15-43.21.26-96.5.26s-96.51-.11-96.51-.26,43.2-.26,96.51-.26S350.73,265.61,350.73,265.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.75,423.62s.18-.31.45-.92a6.52,6.52,0,0,0,.48-2.83,25.58,25.58,0,0,0-.75-4.55,14.36,14.36,0,0,1-.37-6.16,9.19,9.19,0,0,1,4.53-5.85,8.66,8.66,0,0,1,8.4.3,8.39,8.39,0,0,1,3.28,3.37,4.11,4.11,0,0,1,.41,2.48,2.18,2.18,0,0,1-1.88,1.73,18,18,0,0,1-2.53.06l-2.52,0c-1.69,0-3.41-.11-5.15-.27a37.43,37.43,0,0,1-9.94-2.15c-1.52-.51-3.15-.9-4.52-.27s-2.28,2-3.42,3a4.3,4.3,0,0,1-2,1.13,3.15,3.15,0,0,1-2.24-.4,19.77,19.77,0,0,1-3.09-2.83,4.37,4.37,0,0,0-1.57-1,2.51,2.51,0,0,0-1.71.05,9.68,9.68,0,0,0-2.66,2.24,6.6,6.6,0,0,1-5.78,1.81,6.26,6.26,0,0,1-3.92-2.45,6.45,6.45,0,0,1-1.16-2.71,4.36,4.36,0,0,1-.06-1s0,.35.16,1a6.62,6.62,0,0,0,1.22,2.61,6,6,0,0,0,3.81,2.28,6.25,6.25,0,0,0,5.47-1.79,9.91,9.91,0,0,1,2.77-2.34,2.86,2.86,0,0,1,2-.07,4.74,4.74,0,0,1,1.72,1.1,20.62,20.62,0,0,0,3,2.75,2.67,2.67,0,0,0,1.93.34,3.83,3.83,0,0,0,1.8-1c1.09-1,2-2.33,3.54-3.06a4.7,4.7,0,0,1,2.46-.35,11.85,11.85,0,0,1,2.42.58,36.69,36.69,0,0,0,9.83,2.12c1.72.16,3.43.23,5.12.27l2.51.05a19.38,19.38,0,0,0,2.43-.05,1.65,1.65,0,0,0,1.47-1.33,3.56,3.56,0,0,0-.36-2.16,8,8,0,0,0-3.07-3.18,8.23,8.23,0,0,0-8-.33,8.79,8.79,0,0,0-4.37,5.56,14.17,14.17,0,0,0,.3,6,24.85,24.85,0,0,1,.66,4.6,6.37,6.37,0,0,1-.58,2.89A4.6,4.6,0,0,1,317.75,423.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216,402.56c0,.15-12.33.26-27.54.26s-27.55-.11-27.55-.26,12.33-.26,27.55-.26S216,402.42,216,402.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.49,402.14a100.89,100.89,0,0,1-10.17.26,100.89,100.89,0,0,1-10.17-.26,100.89,100.89,0,0,1,10.17-.26A100.89,100.89,0,0,1,243.49,402.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.15,394.18c0,.15-11.1.26-24.79.26s-24.79-.11-24.79-.26,11.1-.26,24.79-.26S336.15,394,336.15,394.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.31,413.67a2.74,2.74,0,0,1-.68.05l-1.93,0-7.12.07c-6,.05-14.31.16-23.48.43s-17.46.63-23.46.93l-7.11.36-1.94.08a3.11,3.11,0,0,1-.67,0,3.14,3.14,0,0,1,.67-.1l1.92-.17c1.68-.15,4.11-.33,7.11-.52,6-.4,14.29-.83,23.47-1.09s17.48-.33,23.49-.28c3,0,5.44.05,7.12.1l1.94.07A5,5,0,0,1,346.31,413.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,304.49a2.12,2.12,0,0,1,0-.4c0-.3,0-.68,0-1.15,0-1,0-2.47-.06-4.27,0-3.69-.07-8.87-.11-15.07l.22.22-20.89,0c-.06.05.49-.49.25-.26h0v11c0,3.5,0,6.81,0,9.85l-.23-.22,15.08.11,4.27.06,1.14,0,.41,0a1.44,1.44,0,0,1-.36,0l-1.1,0-4.22.05-15.22.12h-.22v-.23c0-3,0-6.35,0-9.85v-5.4c0-.93,0-1.86,0-2.8v-2.82h0c-.23.23.32-.32.27-.26l20.89,0H182v.23c-.05,6.26-.09,11.49-.12,15.22,0,1.78,0,3.19-.06,4.22,0,.45,0,.81,0,1.09A1.44,1.44,0,0,1,181.76,304.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 288.38,
    width: 145.76,
    height: 12.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,340.74a2.45,2.45,0,0,1,0-.41c0-.3,0-.67,0-1.14,0-1,0-2.47-.06-4.27,0-3.69-.07-8.87-.11-15.08l.22.23-20.89,0,.25-.25h0v11c0,3.51,0,6.82,0,9.86l-.23-.23,15.08.12,4.27.06,1.14,0,.41,0a1.44,1.44,0,0,1-.36,0l-1.1,0-4.22.06-15.22.12h-.22v-.23c0-3,0-6.35,0-9.86v-5.4c0-.92,0-1.85,0-2.79v-2.83h0l.27-.27,20.89,0H182v.22c-.05,6.27-.09,11.5-.12,15.22,0,1.78,0,3.2-.06,4.22,0,.45,0,.81,0,1.1A1.44,1.44,0,0,1,181.76,340.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 324.63,
    width: 145.76,
    height: 12.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.76,377a2.45,2.45,0,0,1,0-.41c0-.3,0-.68,0-1.14,0-1,0-2.47-.06-4.27,0-3.69-.07-8.88-.11-15.08l.22.23-20.89,0c-.06.06.49-.49.25-.26h0v11c0,3.51,0,6.82,0,9.86l-.23-.23,15.08.12,4.27.06,1.14,0,.41,0a2.13,2.13,0,0,1-.36,0l-1.1,0-4.22.06-15.22.11h-.22V377c0-3,0-6.35,0-9.86v-5.4c0-.92,0-1.86,0-2.8v-2.82h0c-.23.23.32-.32.27-.26l20.89,0H182v.22c-.05,6.26-.09,11.5-.12,15.22,0,1.78,0,3.2-.06,4.22,0,.45,0,.81,0,1.1A1.54,1.54,0,0,1,181.76,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.9,
    y: 360.87,
    width: 145.76,
    height: 12.16,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.23 293.1 167.04 290.28 172.47 295.11 183.14 284.85 185.75 287.67 172.07 300.54 164.23 293.1",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.23 328.13 167.04 325.31 172.47 330.14 183.14 319.88 185.75 322.7 172.07 335.57 164.23 328.13",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "164.23 364.05 167.04 361.24 172.47 366.06 183.14 355.8 185.75 358.62 172.07 371.5 164.23 364.05",
    style: {
      fill: "#F39500"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Text--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.13,141.36c0,5.84-3.5,9.1-8.62,9.1a9,9,0,0,1-4.68-1.16l1.45-2.87a5.44,5.44,0,0,0,3.16.84c2.8,0,4.63-1.66,4.75-4.92a5.75,5.75,0,0,1-4.19,1.52c-3.26,0-5.82-2.07-5.82-5.26,0-3.45,2.82-5.62,6.39-5.62C277.26,133,280.13,135.91,280.13,141.36Zm-4.37-2.94c0-1.45-1.09-2.51-2.94-2.51a2.53,2.53,0,0,0-2.83,2.51c0,1.54,1.14,2.53,2.87,2.53A2.62,2.62,0,0,0,275.76,138.42Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,141.72c0-5.57,3.09-8.73,7.24-8.73s7.24,3.16,7.24,8.73-3.07,8.74-7.24,8.74S282,147.3,282,141.72Zm10.54,0c0-3.83-1.35-5.42-3.3-5.42s-3.28,1.59-3.28,5.42,1.35,5.43,3.28,5.43S292.55,145.56,292.55,141.72Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.4,141.72c0-5.57,3.08-8.73,7.23-8.73s7.24,3.16,7.24,8.73-3.06,8.74-7.24,8.74S298.4,147.3,298.4,141.72Zm10.54,0c0-3.83-1.35-5.42-3.31-5.42s-3.28,1.59-3.28,5.42,1.35,5.43,3.28,5.43S308.94,145.56,308.94,141.72Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.15,133.28v16.89h-3.91V136.42h-3.38v-3.14Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.42,163.15H203V118.71H328.42Zm-124.45-1H327.42V119.71H204Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.47,
    y: 119.21,
    width: 56.3,
    height: 43.44,
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.26,134H217v16.17h-3.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.57,148.57l1.27-2.82a9.47,9.47,0,0,0,5.34,1.69c2.21,0,3.12-.74,3.12-1.73,0-3-9.41-1-9.41-7,0-2.74,2.22-5,6.82-5a10.81,10.81,0,0,1,5.61,1.43L231.17,138a9.18,9.18,0,0,0-4.48-1.27c-2.22,0-3.08.83-3.08,1.85,0,3,9.41.92,9.41,6.86,0,2.7-2.25,5-6.87,5A11.51,11.51,0,0,1,219.57,148.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.56,142.08c0-4.8,3.74-8.36,8.85-8.36s8.85,3.53,8.85,8.36-3.77,8.36-8.85,8.36S234.56,146.89,234.56,142.08Zm13.91,0a5.06,5.06,0,1,0-5.06,5.18A4.93,4.93,0,0,0,248.47,142.08Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.11,431.45,423,449.68l-22.55,24.91c-2.25-2.3,4.64-19.51,4.64-19.51l-12.45-12Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411,446.4a1.38,1.38,0,0,1,1.8.35,1.31,1.31,0,0,1-.33,1.78,1.44,1.44,0,0,1-1.9-.37,1.36,1.36,0,0,1,.55-1.82",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423,449.68,421,447.76l-20.77,24.78s-.52,1.55.38,2.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.64,455.37c.12.11.73-.45,1.66-.7s1.73-.1,1.79-.25-.82-.61-1.94-.3S404.5,455.3,404.64,455.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.35,459c.1.14.78-.2,1.67-.15s1.54.43,1.64.3-.45-.82-1.56-.86S403.24,458.85,403.35,459Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.14,463.28c.15-.11-.21-.77-1.28-1.1s-1.73,0-1.68.18.73.11,1.51.37S405,463.39,405.14,463.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,452.49c.16.05.49-.66,1.16-1.3s1.38-1,1.33-1.15-.95,0-1.73.74S401.75,452.47,401.9,452.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.48,449.22s.56-.36,1.12-1.25a7.66,7.66,0,0,0,.79-1.67,7.83,7.83,0,0,0,.26-1.06,2.08,2.08,0,0,0,.05-.64.71.71,0,0,0-.6-.64.89.89,0,0,0-.76.28,1.94,1.94,0,0,0-.35.53,5.53,5.53,0,0,0-.44,1,5.92,5.92,0,0,0-.29,1.84,2.8,2.8,0,0,0,.35,1.65c.09,0,0-.65.06-1.64a6.23,6.23,0,0,1,.38-1.68,6.15,6.15,0,0,1,.42-.91c.17-.33.38-.56.55-.52s.09,0,.12.16a1.65,1.65,0,0,1,0,.47,7.69,7.69,0,0,1-.22,1,8.7,8.7,0,0,1-.63,1.62A13.82,13.82,0,0,0,399.48,449.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.8,449.22c.06,0-.16-.66-.91-1.42a5.41,5.41,0,0,0-1.52-1.06,5.55,5.55,0,0,0-1-.37,1.38,1.38,0,0,0-1.35.22.78.78,0,0,0-.13.84,2.65,2.65,0,0,0,.34.54,3.74,3.74,0,0,0,.84.76,3.83,3.83,0,0,0,1.77.64c1.09.1,1.7-.28,1.66-.33a11.71,11.71,0,0,1-1.6-.07,3.9,3.9,0,0,1-1.53-.67,3.68,3.68,0,0,1-.7-.67c-.23-.28-.35-.57-.23-.65a1,1,0,0,1,.8-.07,5.68,5.68,0,0,1,1,.31,6.07,6.07,0,0,1,1.46.88C399.38,448.73,399.72,449.27,399.8,449.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.92,449l-.25,27-33.6-.14c.21-3.21,17.62-9.58,17.62-9.58L391.14,449Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.09,464.89a1.38,1.38,0,0,1,.94,1.57,1.32,1.32,0,0,1-1.55,1,1.45,1.45,0,0,1-1-1.67,1.37,1.37,0,0,1,1.72-.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.67,476.09l0-2.9-32.32,1.1s-1.49.65-1.32,1.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.14,466.13c0,.17.83.25,1.63.78s1.24,1.22,1.39,1.15-.09-1-1.08-1.63S391.11,466,391.14,466.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.61,467.58c0,.16.68.44,1.23,1.13s.71,1.43.88,1.43.27-.94-.44-1.79S387.62,467.42,387.61,467.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.59,471.79c.15,0,.39-.79,0-1.69s-1.19-1.26-1.26-1.12.41.62.74,1.36S385.43,471.77,385.59,471.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.46,462.17c.07.15.82-.07,1.75,0s1.65.36,1.73.22-.6-.73-1.7-.79S391.38,462.05,391.46,462.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.23,295a47.73,47.73,0,0,1,7,9.88c2.32,4.83,5.87,15.12,5.87,15.12s4.43,15.72,3.44,23.13S415,401.18,415,401.18s1.3,40.18-4.36,58.06l-1,4.74-18.94-3.36h0l-4.2-99.46L374.84,295.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,299.2c.08,0,0-.62.73-1.09a1.37,1.37,0,0,1,2.14,1.14,1.37,1.37,0,0,1-2.18,1.06c-.66-.49-.61-1.14-.69-1.11s-.08.14-.05.4a1.58,1.58,0,0,0,.54,1,1.7,1.7,0,0,0,1.63.32,1.75,1.75,0,0,0,.06-3.31,1.69,1.69,0,0,0-1.64.27,1.51,1.51,0,0,0-.57.95C382,299.06,382,299.2,382,299.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.05,308.63s-6.95,63.05-7.95,73.88,38.31,68.57,38.31,68.57L407,431.49l-25.3-47,8.52-46.85L379,295.34l-17.44.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.49,444.06a12.9,12.9,0,0,1-.14,1.38c-.11.9-.34,2.23-.65,3.94-.63,3.44-1.65,8.41-3,14.63l0,.13-.13,0-18.95-3.33-.15,0v-.15c-.53-13-1.16-28.54-1.84-45.2-.7-17.94-1.34-34.56-1.88-48.2h0c-1.42-11-2.6-20-3.42-26.36-.4-3.15-.71-5.62-.92-7.33-.1-.83-.18-1.47-.23-1.92s-.06-.67-.06-.67.05.23.11.66.16,1.09.28,1.92c.24,1.7.58,4.17,1,7.31.86,6.34,2.08,15.39,3.57,26.35h0c.55,13.64,1.23,30.27,1.95,48.2.65,16.66,1.26,32.21,1.77,45.21l-.15-.17,18.93,3.4-.16.11c1.41-6.21,2.48-11.17,3.15-14.59.34-1.71.59-3,.73-3.93.07-.45.12-.8.15-1A2.85,2.85,0,0,1,413.49,444.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.8,320.6a7.28,7.28,0,0,0-1,0,4.71,4.71,0,0,1-2.67-.45,2.52,2.52,0,0,1-1.07-1.44,10,10,0,0,1-.32-2.17c-.14-1.57-.27-3.3-.39-5.12-.25-3.63-.38-6.93-.46-9.32,0-1.12-.08-2.06-.1-2.82a4.86,4.86,0,0,0-.09-1,4.86,4.86,0,0,0-.09,1c0,.67,0,1.63,0,2.83,0,2.39.09,5.7.33,9.34.12,1.83.27,3.56.43,5.13a9.53,9.53,0,0,0,.38,2.25,2.8,2.8,0,0,0,1.26,1.59,3.45,3.45,0,0,0,1.61.42,7.6,7.6,0,0,0,1.24-.06A3.7,3.7,0,0,0,384.8,320.6Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.81,308.68a6.86,6.86,0,0,0,1.81-1,19.22,19.22,0,0,0,3.73-3.25,18.71,18.71,0,0,0,2.74-4.12,6.6,6.6,0,0,0,.72-1.92,25.43,25.43,0,0,1-9,10.25Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.22,168.21a13.72,13.72,0,0,0-4.22,12c.32,2.12,1.09,4.51-.18,6.24s-3.95,1.87-5.14,3.62c-1.4,2.07.11,4.87-.26,7.34a5,5,0,0,1-5,4.06,19.33,19.33,0,0,0,9.85,3.42l2.41-3.62a3.55,3.55,0,0,0,.56,4.32,8.14,8.14,0,0,0,4.16,2.07,24.51,24.51,0,0,0,21.14-5.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.67,184.05a50.71,50.71,0,0,1-2.14-4.7c-1-3.55.41-7.75-1.58-10.87-1.42-2.22-4.16-3.16-6.73-3.74s-5.32-1-7.33-2.75c-1.47-1.25-2.39-3.05-3.87-4.31-2.09-1.78-5-2.22-7.78-2.19a16.57,16.57,0,0,0-8.16,2,9.06,9.06,0,0,0-4.61,6.74,26.89,26.89,0,0,1-.17,4.12c-.37,1.47-1.41,2.68-2,4.07a7.25,7.25,0,0,0,2.46,8.54l21.19,23.53c4.18,1.23,13.88-1.36,16.79-4.59S410.33,188.07,408.67,184.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,177.71c.37-5.73,4.19-12.75,9.89-12.13l17.82,4.54a3.37,3.37,0,0,1,3,3.42l-2,43,.13,0s-7.11,16.9-18.89,13.2c-2.33-.74-.36-8.07-.82-10.7l-.21-6.79c0-3.47,0-4.89,0-4.86s-7.31-1.23-8.81-10.79C366.35,191.86,366.6,184.07,367,177.71Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.39,185.87a1.22,1.22,0,0,0,1.17,1.24,1.18,1.18,0,0,0,1.27-1.1,1.23,1.23,0,0,0-1.18-1.24A1.16,1.16,0,0,0,368.39,185.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.23,186.27a1.23,1.23,0,0,0,1.18,1.24,1.18,1.18,0,0,0,1.27-1.1,1.23,1.23,0,0,0-1.18-1.24A1.17,1.17,0,0,0,380.23,186.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.2,181.93c.15.21,1.23-.59,2.66-.49s2.42,1,2.59.81-.05-.46-.48-.88a3.24,3.24,0,0,0-4.19-.26C368.31,181.47,368.13,181.83,368.2,181.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,182.46c.19.2,1.24-.7,2.77-.74s2.68.73,2.84.52-.11-.44-.61-.81a3.81,3.81,0,0,0-2.28-.67,3.65,3.65,0,0,0-2.2.85C381,182,380.87,182.38,381,182.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.85,191.8a9.44,9.44,0,0,0-2.14-.39c-.34,0-.66-.1-.71-.33a1.68,1.68,0,0,1,.23-1c.31-.81.65-1.66,1-2.56a44.58,44.58,0,0,0,2.25-6.7,43.78,43.78,0,0,0-2.79,6.51l-1,2.57a2,2,0,0,0-.17,1.32.85.85,0,0,0,.55.5,2.51,2.51,0,0,0,.57.08A8.3,8.3,0,0,0,376.85,191.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.9,207.4A24.29,24.29,0,0,0,388.7,204s-3.23,6.69-12.79,5.78Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.55,195.07a2.38,2.38,0,0,1,2.27-.38,2.21,2.21,0,0,1,1.28,1.12,1.37,1.37,0,0,1-.25,1.55,1.58,1.58,0,0,1-1.78,0,4.93,4.93,0,0,1-1.42-1.35,1.63,1.63,0,0,1-.28-.47.46.46,0,0,1,.11-.48",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.73,193.51c-.22,0-.22,1.41-1.45,2.43s-2.75.85-2.76,1.05.34.28,1,.3a3.61,3.61,0,0,0,2.31-.8,3.13,3.13,0,0,0,1.12-2C381,193.85,380.82,193.5,380.73,193.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.76,178.91c.13.36,1.44.2,3,.39s2.8.61,3,.29c.09-.15-.12-.49-.63-.84a5.24,5.24,0,0,0-4.56-.51C381,178.46,380.7,178.74,380.76,178.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.16,176.55c.27.3,1.31,0,2.55,0s2.31.21,2.55-.11c.11-.15-.06-.45-.52-.73a4.12,4.12,0,0,0-4.11.1C369.19,176.1,369.05,176.4,369.16,176.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.68,171.2a7.88,7.88,0,0,0-4.15-2.33A88.25,88.25,0,0,0,374,165.25c-.75,1.47.19,3.34,1.56,4.27a16.15,16.15,0,0,0,4.65,1.68,6.18,6.18,0,0,1,4,2.71c.79,1.57.37,3.53,1.08,5.14,1.24,2.77,5.28,3.39,6.5,6.17.92,2.1-.15,4.49-.3,6.77a8.2,8.2,0,0,0,8.72,8.71q-.21-12.3-.41-24.6C399.78,174.4,399.71,172.56,398.68,171.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.66,190.6c-1.38-1.06-3.07-1.94-3.7-3.56-.93-2.35.79-5.32-.62-7.42-1.28-1.92-4.62-1.57-5.83-3.53-.94-1.53-.1-3-.52-4.4a3.85,3.85,0,0,0-3.91-2.18l-9.95,17c-.63,5.49-1.45,8.46-.05,11.54a26,26,0,0,1,2.11,5.14,5.27,5.27,0,0,1-1.35,5.13c6.71,0,12.69-3.93,18.21-7.73l5.85-4a4.32,4.32,0,0,0,1.57-1.52C419.26,193.48,418,191.66,416.66,190.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.1,198.93a2.91,2.91,0,0,1-.7.19,5.92,5.92,0,0,1-2.09,0,6.53,6.53,0,0,1-3-1.34,6.33,6.33,0,0,1-2.2-3.76,6.56,6.56,0,0,1,0-2.57,10.31,10.31,0,0,1,1.05-2.57,10,10,0,0,0,1.09-2.66,3.35,3.35,0,0,0-.57-2.8c-.67-.77-1.81-.88-2.88-1.23a2.69,2.69,0,0,1-2.09-2.66,18.77,18.77,0,0,1,.5-3.53,3.75,3.75,0,0,0-.12-1.7,2.38,2.38,0,0,0-1.06-1.28,6.8,6.8,0,0,0-3.44-.65,7.29,7.29,0,0,1-3.51-.75,6.47,6.47,0,0,1-2.54-2.38,10.39,10.39,0,0,1-1.11-3.13,14.6,14.6,0,0,0-.88-2.94,6.49,6.49,0,0,0-1.74-2.25,7.53,7.53,0,0,0-8.83-.58,9.15,9.15,0,0,0-2.42,2.15,12.27,12.27,0,0,0-1.42,2.39s0-.06,0-.18.1-.29.2-.5a8.6,8.6,0,0,1,1-1.8,8.91,8.91,0,0,1,2.43-2.24,7.8,7.8,0,0,1,4.18-1.26,8,8,0,0,1,5,1.77,7.08,7.08,0,0,1,1.85,2.35,15.2,15.2,0,0,1,.91,3,10.59,10.59,0,0,0,1.08,3,6.12,6.12,0,0,0,2.39,2.23,7,7,0,0,0,3.35.7,7,7,0,0,1,3.63.71,2.76,2.76,0,0,1,1.23,1.48,4.16,4.16,0,0,1,.13,1.88,20,20,0,0,0-.5,3.46,2.67,2.67,0,0,0,.5,1.5,2.77,2.77,0,0,0,1.32.83c.52.17,1.06.28,1.6.46a3.19,3.19,0,0,1,1.44.88,3.64,3.64,0,0,1,.63,3.1,10.12,10.12,0,0,1-1.13,2.75,10.2,10.2,0,0,0-1.05,2.49,6.54,6.54,0,0,0-.05,2.45,6.13,6.13,0,0,0,2.07,3.64,6.32,6.32,0,0,0,2.9,1.36A7,7,0,0,0,411.1,198.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.13,186.79a1.38,1.38,0,0,1,.27.52,2.42,2.42,0,0,1-.17,1.68,2.57,2.57,0,0,1-.78,1,2.67,2.67,0,0,1-1.4.48A3.34,3.34,0,0,1,414,188.8a4.48,4.48,0,0,1-.62-2,6.21,6.21,0,0,1,.3-2.24c.42-1.48,1.28-3,1.17-4.64a3.11,3.11,0,0,0-.94-2.24,3.41,3.41,0,0,0-2.48-.57,8.2,8.2,0,0,1-2.91-.09,2.54,2.54,0,0,1-1.26-.91,3.55,3.55,0,0,1-.6-1.43,11.86,11.86,0,0,1,0-3,6.44,6.44,0,0,0-.36-2.74,6.94,6.94,0,0,0-3.4-3.84,9.91,9.91,0,0,0-4.7-.71,13.69,13.69,0,0,1-4.27-.35,9,9,0,0,1-4.92-3.63,6.41,6.41,0,0,1-.95-2.06,12,12,0,0,0,1.07,2A9.14,9.14,0,0,0,394,163.8a13.76,13.76,0,0,0,4.19.29,10.16,10.16,0,0,1,4.87.71,7.28,7.28,0,0,1,3.6,4,6.88,6.88,0,0,1,.39,2.89,11.58,11.58,0,0,0,0,2.88,2.49,2.49,0,0,0,1.59,2.06,8.27,8.27,0,0,0,2.77.07,3.72,3.72,0,0,1,2.74.67,3.46,3.46,0,0,1,1.06,2.5,6.6,6.6,0,0,1-.42,2.53c-.27.78-.58,1.51-.8,2.23a5.87,5.87,0,0,0-.31,2.12,4.1,4.1,0,0,0,.56,1.87,3.1,3.1,0,0,0,2.81,1.57,2.48,2.48,0,0,0,1.3-.42,2.51,2.51,0,0,0,.76-.88,2.41,2.41,0,0,0,.22-1.59A3.88,3.88,0,0,0,419.13,186.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.18,196a2.74,2.74,0,0,0,.16,1.75,2.31,2.31,0,0,0,1.49,1.3,2.43,2.43,0,0,0,2.39-.85,2.19,2.19,0,0,0,.47-1.44,4.44,4.44,0,0,0-.38-1.67c-.44-1.1-1.25-2.28-1.25-3.76a5.39,5.39,0,0,1,1.74-4,6.26,6.26,0,0,1,2-1.25,9.33,9.33,0,0,1,2.34-.52,12.56,12.56,0,0,0,2.29-.41,3.09,3.09,0,0,0,1.71-1.25,3.66,3.66,0,0,0,.5-2,7.37,7.37,0,0,0-.32-2,15.7,15.7,0,0,1-.89-3.86,5.87,5.87,0,0,1,.95-3.32,7.51,7.51,0,0,1,2-2,14.74,14.74,0,0,0,1.65-1.33,4.46,4.46,0,0,0,1-1.48.45.45,0,0,1,0,.11,1.43,1.43,0,0,1-.11.34,3.63,3.63,0,0,1-.75,1.14,13.78,13.78,0,0,1-1.62,1.39,7.74,7.74,0,0,0-1.94,2,5.7,5.7,0,0,0-.86,3.17,15.73,15.73,0,0,0,.91,3.77,7.86,7.86,0,0,1,.36,2.14,4.21,4.21,0,0,1-.55,2.22,3.48,3.48,0,0,1-1.92,1.42,12.72,12.72,0,0,1-2.36.43,9.1,9.1,0,0,0-2.25.49,6.15,6.15,0,0,0-1.88,1.17,5.05,5.05,0,0,0-1.64,3.72c0,1.35.74,2.48,1.19,3.64a4.72,4.72,0,0,1,.38,1.79,2.51,2.51,0,0,1-.55,1.61,2.66,2.66,0,0,1-2.67.89,2.56,2.56,0,0,1-1.74-2.81A1.39,1.39,0,0,1,349.18,196Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.11 230.7 403.19 296.06 378.99 295.34 360.37 299.11 365.32 228.22 375.31 216.95 382.2 230.53 395.76 214.88 408.11 230.7",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.08,208.79l5.11,4.28,21.2,6.53-7.69,57.15L421,304.31l6.63,25.95s-19.54,5.32-24.57,2.41-11.17-31.14-13-37.84-4.66-26.64-3.36-37.25,3.54-26.26,4.66-31.66S396.08,208.79,396.08,208.79Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.39,219.6s5.08,6.64,6.52,13c2.43,10.78,11.83,40.2,11.27,47.1s-37,19.39-37,19.39l-1.49-19.18L418.66,271,414,252.92",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,252.92a1.24,1.24,0,0,0,.06.32c.05.23.12.53.21.92.21.83.5,2,.88,3.56.79,3.13,1.92,7.65,3.35,13.32l.08-.17-17,8.88-.11.06v.13c.44,5.83.94,12.31,1.46,19.19l0,.29.28-.1c7.14-2.51,14.82-5.44,22.56-9,2.55-1.2,5-2.43,7.41-3.82s4.72-2.82,6.41-5a4.69,4.69,0,0,0,.52-.9,2.32,2.32,0,0,0,.16-.51,1.62,1.62,0,0,0,.07-.52,14.54,14.54,0,0,0-.07-2c-.11-1.31-.35-2.58-.56-3.84q-.73-3.77-1.62-7.31c-2.35-9.46-4.84-17.86-6.79-25-1-3.54-1.83-6.75-2.52-9.6a31.66,31.66,0,0,0-2.94-6.91,45.43,45.43,0,0,0-2.52-4c-.31-.44-.56-.78-.73-1a3.69,3.69,0,0,0-.27-.32s.07.12.23.35l.69,1c.59.91,1.46,2.25,2.43,4.06a31.53,31.53,0,0,1,2.85,6.89c.67,2.84,1.48,6.08,2.45,9.62,1.92,7.11,4.38,15.53,6.7,25,.58,2.36,1.11,4.8,1.6,7.29.2,1.25.43,2.51.54,3.8a15.41,15.41,0,0,1,.07,1.92,3,3,0,0,1-.67,1.68c-1.58,2-3.95,3.47-6.27,4.86s-4.83,2.61-7.37,3.8c-7.71,3.58-15.39,6.52-22.51,9l.3.2c-.54-6.87-1.05-13.35-1.51-19.18l-.11.19,16.92-9,.1-.05,0-.12-3.48-13.28c-.41-1.53-.73-2.71-.95-3.54l-.26-.91A1.59,1.59,0,0,0,414,252.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.91,210.13l-2.71,3.58L358,219.53s-1.21,14-1.21,18.26,1.77,51.76,1.77,54-8.57,32.59-7.82,34.45,9.68,3.17,9.68,3.17,3.36-26.26,3.36-35.2.37-30.91,2.23-41.72S376,218,376,218Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358,219.53s-4.07,1.76-4.53,11.14-1.23,30.63-1.23,30.63-2.62,3.54-2.93,6.47-5.23,20-5.23,20l11.08,3.69,2.84-5.23,2.4-51.87Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.55,299.2a1.76,1.76,0,0,0,0-.22v-.65c0-.62,0-1.45,0-2.51,0-2.22-.12-5.36-.21-9.22-.18-7.79-.5-18.54-.69-30.42,0-1.49,0-3,0-4.4s.15-2.84.26-4.24c.22-2.8.44-5.49.7-8s.56-5,.94-7.23a30.45,30.45,0,0,1,1.74-6.08,78.13,78.13,0,0,1,3.9-8.33c.5-.93.9-1.66,1.2-2.2l.31-.57c.07-.13.1-.2.09-.2a.71.71,0,0,0-.13.17l-.36.55c-.3.49-.74,1.21-1.27,2.16a70.46,70.46,0,0,0-4.06,8.3,31.18,31.18,0,0,0-1.81,6.13c-.4,2.26-.71,4.7-1,7.26s-.51,5.26-.74,8.05c-.11,1.39-.27,2.81-.27,4.28s0,2.92,0,4.41c.2,11.88.56,22.63.83,30.42.15,3.86.28,7,.36,9.21.06,1.06.1,1.9.13,2.51,0,.26,0,.48,0,.65A.74.74,0,0,0,363.55,299.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.54,279.72a3.6,3.6,0,0,0,.1-.7c0-.46.1-1.14.15-2,.1-1.75.19-4.29.14-7.43,0-1.57-.08-3.29-.18-5.13a25.26,25.26,0,0,1,.63-5.77,104,104,0,0,1,3.86-12.73c1.62-4.43,3.3-8.6,4.85-12.37a52.1,52.1,0,0,0,2.07-5.44c.5-1.77.82-3.46,1.1-5,.54-3.08.83-5.6,1-7.35.09-.87.16-1.55.19-2a3.08,3.08,0,0,0,0-.7,5.8,5.8,0,0,0-.11.69c-.07.5-.16,1.17-.27,2-.25,1.73-.58,4.24-1.16,7.3-.29,1.53-.63,3.21-1.14,4.95a53.71,53.71,0,0,1-2.09,5.38c-1.57,3.76-3.26,7.93-4.88,12.37A102.24,102.24,0,0,0,388,258.57a25.43,25.43,0,0,0-.6,5.9c.12,1.83.2,3.54.24,5.11.09,3.13,0,5.66,0,7.41,0,.84-.05,1.51-.07,2S387.53,279.71,387.54,279.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.14,278.25,344.31,292a1.87,1.87,0,0,0,1.84.72l44-8.31a1.87,1.87,0,0,0,1.42-2.4l-4.75-14.6a1.85,1.85,0,0,0-2.1-1.25l-49.4,9.17A1.86,1.86,0,0,0,334.14,278.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.91,272.2a4.33,4.33,0,0,0-1.48-1.19,9,9,0,0,0-8.88-.12A4.11,4.11,0,0,0,417,272c0,.06.62-.38,1.66-.85a10,10,0,0,1,4.3-.93,10.13,10.13,0,0,1,4.27,1C428.3,271.81,428.86,272.26,428.91,272.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "419.5 297.9 401.13 304.66 399.32 297.45 391.09 299.11 389.98 294.94 402.89 293.13 403.02 299.11 418.44 293.29 419.5 297.9"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M401.84,281.46s-3.48-2.93-4.55-3.6-4.72-3.06-6.38-2.81l-1.65.25,1.49,4.38s-13.33-2-15.15.17,2,2.57,4,2.81,8.37,1.33,8.37,1.33-16.64-1.82-17.8,0,1.61,2.23,1.61,2.23l11,4.39,1.26.5,1.27,1.65s4.53,3.15,5.93,2.73,11.28-2.36,11.28-2.36Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.26,289a13.64,13.64,0,0,0-2.58-.78,63.78,63.78,0,0,0-6.39-1.23c-2.52-.35-4.82-.52-6.49-.58a13.59,13.59,0,0,0-2.7.05,17.76,17.76,0,0,0,2.68.29c1.65.14,3.93.36,6.44.71s4.76.77,6.39,1.09A18.08,18.08,0,0,0,390.26,289Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.75,292.19a6.87,6.87,0,0,0-2.39-.87,6.78,6.78,0,0,0-2.5-.4,7,7,0,0,0,2.38.87A6.82,6.82,0,0,0,388.75,292.19Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.8,273s-2-2.28-3.53-2.28c-1.36,0-2.42.79-2.42,1.84v1.55Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.07,231.27a2.3,2.3,0,0,0-.08.61l-.13,1.76c-.12,1.52-.2,3.74-.25,6.47-.1,5.48.15,13,.7,21.37s1,15.86,1.12,21.32c.06,2.73.08,4.94.06,6.47V291a2.78,2.78,0,0,0,0,.62,5,5,0,0,0,.06-.61c0-.46.05-1,.09-1.76.08-1.53.11-3.75.09-6.48,0-5.48-.44-13-1-21.35s-.85-15.87-.83-21.33c0-2.73,0-5,.09-6.47,0-.73,0-1.31,0-1.76A3.64,3.64,0,0,0,357.07,231.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.68,251a6.33,6.33,0,0,0,.08-1.22c0-.79.06-1.93.16-3.33a58.35,58.35,0,0,1,1.79-10.81,59.61,59.61,0,0,1,3.84-10.27c.62-1.26,1.14-2.27,1.53-3a6.09,6.09,0,0,0,.54-1.1,5.35,5.35,0,0,0-.7,1c-.44.66-1,1.65-1.67,2.9a51.44,51.44,0,0,0-4,10.3,50.76,50.76,0,0,0-1.67,10.91c-.05,1.41-.05,2.56,0,3.35A6.31,6.31,0,0,0,412.68,251Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.85,280.55s-1.48,2-1,3.56,4.27,4.46,4.27,4.46,1.44,1.71,2.1,1.71,3.78.56,3.56-1.3-3-2.18-3-2.18-.07-.67-1.25-1.52L338,283.43Z",
    style: {
      fill: "#ffbf9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.52,288.06s.14.28.56.52a2.24,2.24,0,0,0,1.88.17,1.84,1.84,0,0,0,.86-.68,1.56,1.56,0,0,0,.25-.86c0-.52-.28-.75-.32-.72s.05.3,0,.7a1.44,1.44,0,0,1-.94,1.11,2.32,2.32,0,0,1-1.57,0C338.81,288.14,338.56,288,338.52,288.06Z",
    style: {
      fill: "#ff9a6c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.71,270a13.62,13.62,0,0,0-4.13-7.63c-.11.09,1.14,1.6,2.27,3.7S357.57,270,357.71,270Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.9,353.28l-7.57,17.08s19.91,7.9,20.07,11.65l-38.74-.71,0-3.28,8.54-28.18Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,367.3a1.59,1.59,0,0,0-1.12,1.8,1.51,1.51,0,0,0,1.76,1.15,1.69,1.69,0,0,0,1.18-1.92,1.57,1.57,0,0,0-2-1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.66,381.3l0-3.28,37.19,2s1.71.8,1.5,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133,370.18c0,.19-1,.26-1.89.86s-1.46,1.39-1.63,1.31.13-1.18,1.28-1.88S133,370,133,370.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,372c0,.19-.79.5-1.44,1.3s-.86,1.65-1.05,1.64-.29-1.1.55-2.08S137,371.77,137,372Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.22,376.92c-.18,0-.42-.92.08-2s1.4-1.45,1.48-1.28-.48.71-.89,1.57S139.4,376.91,139.22,376.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.38,365.72c-.09.17-.95-.11-2-.05s-1.91.38-2,.21.71-.83,2-.88S134.47,365.57,134.38,365.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "73.04 409.34 72.18 441.92 89.08 441.87 89.99 410.08 73.04 409.34",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.57,440.27c.14,0,.36-6.95.48-15.52s.1-15.52,0-15.52-.35,6.94-.47,15.52S80.43,440.27,80.57,440.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.37,431.71s-.11-.28-.41-.7a12.25,12.25,0,0,0-1.47-1.67,11.57,11.57,0,0,0-2.69-1.92,8.92,8.92,0,0,0-10.57,1.74A7.81,7.81,0,0,0,73,431a2.56,2.56,0,0,0-.29.77,19.09,19.09,0,0,1,1.83-2.35,8.94,8.94,0,0,1,6.39-2.49,10.32,10.32,0,0,1,6.37,2.69C88.63,430.81,89.3,431.77,89.37,431.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "72.24 441.95 89.07 441.87 89.19 438.02 72.22 438.1 72.24 441.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,259.87l37-6.48.14,4c8.93,7.25,32.72,28,47.09,42.16,0,0,5.33,7.16,3.22,13.76L135.69,369l-22-4L129,316,86.09,295.67c-8.34-3.13-15.86-13.8-17.64-19.92C66.93,270.52,70.22,266.57,70.44,259.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.88,301,91.07,420.62l-21.85.57S67.36,388.57,67,363.9c-.33-22.57-.56-78.51-.56-78.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.44,259.87,58.89,262s-.42,28.71.39,31.59S67,304.71,67,304.71l32.07,6.21V285.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.99 275.1 66.16 283.18 57.38 283.18 58.88 275.1 66.99 275.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.41,283.18a3,3,0,0,0,.27.61,16.84,16.84,0,0,0,.92,1.7A24,24,0,0,0,79.08,291a40.47,40.47,0,0,0,8.64,5.89c3.47,1.84,7.44,3.54,11.53,5.47l21,9.75,6.39,2.91,1.75.77a4.18,4.18,0,0,0,.62.24,2.74,2.74,0,0,0-.58-.33l-1.71-.85-6.33-3-21-9.88c-4.09-1.94-8.06-3.62-11.52-5.43a41.45,41.45,0,0,1-8.62-5.75,24.8,24.8,0,0,1-4.54-5.32C73.86,284,73.45,283.16,73.41,283.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.93,303.11a72,72,0,0,0,6.84,4.61,71,71,0,0,0,7.1,4.21A71.48,71.48,0,0,0,73,307.32,70.26,70.26,0,0,0,65.93,303.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.88,275.1a14.08,14.08,0,0,0-.55,2.24c-.31,1.43-.71,3.44-1.16,5.8l-.05.26h.26l4.34,0,4.44,0h.2l0-.2c.23-2.36.4-4.39.51-5.82a13.91,13.91,0,0,0,.1-2.28,14.11,14.11,0,0,0-.36,2.25c-.19,1.43-.43,3.44-.69,5.81l.22-.2-4.44,0-4.34,0,.22.26c.42-2.36.76-4.39,1-5.83A14,14,0,0,0,58.88,275.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.68,269.63s-.12,0-.38,0l-1.16.2-4.37.8-15.2,2.9-.22,0,0,.22c.37,2.53.77,5.26,1.19,8.08l0,.25.25-.06.25-.05c8.76-2,16.61-3.89,21.83-5.15l.17,0-.06-.16c-.72-2.2-1.3-4-1.73-5.25l-.46-1.38a1.91,1.91,0,0,0-.18-.44,3.86,3.86,0,0,0,.13.52c.1.37.24.84.4,1.42l1.55,5.22.11-.2c-5.24,1.17-13.1,3-21.87,5l-.24.06.28.2c-.42-2.82-.83-5.55-1.21-8.08l-.18.26,15-3.08,4.4-.93,1.19-.27A2.85,2.85,0,0,0,100.68,269.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.9,314a9.19,9.19,0,0,0-2.42-.47,26,26,0,0,0-6,0,24.1,24.1,0,0,0-5.81,1.38,9.14,9.14,0,0,0-2.23,1.07,20.42,20.42,0,0,0,2.34-.76,30.71,30.71,0,0,1,5.75-1.22,34.36,34.36,0,0,1,5.88-.13A21.35,21.35,0,0,0,143.9,314Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.34,257.78c.13,0,.13-.65,0-1.41S101,255,100.9,255s-.13.65,0,1.41S101.21,257.8,101.34,257.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.54,258.35c.13,0,.1-.76-.05-1.64s-.39-1.58-.51-1.56-.11.76,0,1.64S99.41,258.37,99.54,258.35Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.58,260.86c.13,0,.14-.7,0-1.52s-.32-1.47-.45-1.45-.14.7,0,1.52S84.45,260.88,84.58,260.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.88,261.66c.13,0,.13-.82,0-1.8s-.33-1.76-.46-1.74-.13.82,0,1.8S82.75,261.67,82.88,261.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.45,264.17c.13,0,.16-.79.07-1.74s-.28-1.7-.41-1.68-.15.79-.06,1.73S68.32,264.18,68.45,264.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.27,264.74a8.32,8.32,0,0,0-.22-3.88,8,8,0,0,0,.22,3.88Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.63,134c-1.47-1.7-3.26-3.31-3.72-5.51-.41-2,.38-4.29-.62-6.09-1.22-2.23-4.47-2.53-6-4.58-.72-1-.94-2.28-1.66-3.28-1.21-1.71-3.58-2.17-5.66-2s-4.09,1-6.18,1.09c-2.87.18-5.82-.76-8.58,0-3,.89-4.91,3.57-6.89,6.16l-2.59,3a11.31,11.31,0,0,1-1.72,1.38,20.78,20.78,0,0,0-3.27,2.07,5.07,5.07,0,0,0,.3,7.31,5.4,5.4,0,0,0-3.67,5.3,15.44,15.44,0,0,0,1,3.69,5.42,5.42,0,0,1,.09,3.74,2.39,2.39,0,0,1-3.12,1.33,5.69,5.69,0,0,0,3.1,3.81,3.39,3.39,0,0,1-2.3,1c2.3,5.46,8.62,8.36,14.55,8.41s11.62-2.18,17.13-4.38l16-4.1c1.41-.32,2-2,2-3.46s-.38-2.94.14-4.28c.71-1.85,2.86-2.82,3.6-4.65C113.37,138,112.1,135.67,110.63,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.79,148.44a66,66,0,0,1-2.78-11,23,23,0,0,1,1-11.22c.2-.53,1.93-4.13,2.5-4.07.41,0-.66,3.4-.46,3.76a19.42,19.42,0,0,1,2.11,11.38,51.33,51.33,0,0,1-2.35,11.16",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.52,134c-.24-9.5,5.09-17.57,14.6-17.54l.87,0a17,17,0,0,1,16,16.62c.17,8.24.24,17.35-.08,21.74-.67,9.1-9.86,10-9.86,10s.23,15,.23,15L72,165.79Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,164.81a22,22,0,0,1-11.64-4.23s2.46,7.57,11.6,7.3Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.84,140.84a1.3,1.3,0,0,1-1.33,1.24,1.25,1.25,0,0,1-1.27-1.26,1.31,1.31,0,0,1,1.33-1.24A1.25,1.25,0,0,1,100.84,140.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.79,136.77c-.18.16-1.12-.63-2.52-.71s-2.46.55-2.6.37.11-.38.57-.67a3.54,3.54,0,0,1,2.11-.51,3.38,3.38,0,0,1,2,.77C101.74,136.38,101.87,136.69,101.79,136.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9,140.81a1.3,1.3,0,0,1-1.33,1.24,1.25,1.25,0,0,1-1.27-1.26,1.3,1.3,0,0,1,1.33-1.23A1.24,1.24,0,0,1,88.9,140.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88,136.5c-.17.16-1.11-.63-2.51-.71s-2.47.56-2.61.38.11-.38.58-.68a3.53,3.53,0,0,1,2.1-.51,3.39,3.39,0,0,1,2,.78C88,136.11,88.13,136.43,88,136.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.41,147.56a9.13,9.13,0,0,1,2.3-.27c.36,0,.7-.07.78-.31a1.8,1.8,0,0,0-.18-1.07c-.28-.89-.58-1.82-.89-2.79-1.23-4-2.1-7.21-1.94-7.26S93.77,139,95,143c.3,1,.58,1.91.85,2.8a2.09,2.09,0,0,1,.1,1.41.94.94,0,0,1-.62.49,2.74,2.74,0,0,1-.61,0A9.39,9.39,0,0,1,92.41,147.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.23,148.28c.23,0,.14,1.52,1.38,2.67s2.86,1.09,2.86,1.3-.38.28-1.06.25a3.74,3.74,0,0,1-2.4-1A3.28,3.28,0,0,1,88,149.27C87.94,148.63,88.13,148.26,88.23,148.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.31,130.82c-.16.37-1.55.1-3.2.2s-3,.47-3.21.11c-.08-.17.17-.51.73-.85A5.39,5.39,0,0,1,85,129.6a5.31,5.31,0,0,1,2.47.44C88.1,130.32,88.38,130.64,88.31,130.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.49,132.08c-.27.3-1.21-.09-2.37-.17s-2.15.08-2.36-.27c-.09-.16.09-.47.53-.75a3.37,3.37,0,0,1,2-.4,3.23,3.23,0,0,1,1.85.75C101.49,131.59,101.61,131.93,101.49,132.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.85,140.76c-.15-.08-6.14-2.23-6.32,4s6.12,5.13,6.14,4.95S72.85,140.76,72.85,140.76Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.83,147.3s-.11.07-.3.15a1.06,1.06,0,0,1-.81,0A2.68,2.68,0,0,1,68.55,145a3.64,3.64,0,0,1,.34-1.55,1.27,1.27,0,0,1,.85-.81.55.55,0,0,1,.63.32c.08.17,0,.3.07.31s.13-.1.09-.36a.7.7,0,0,0-.23-.4.86.86,0,0,0-.6-.17,1.52,1.52,0,0,0-1.16.93,3.72,3.72,0,0,0-.43,1.73,2.81,2.81,0,0,0,1.51,2.74,1.21,1.21,0,0,0,1-.14C70.81,147.45,70.85,147.31,70.83,147.3Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.13,122.69c1-.54-1.94-3.87-4.4-5-3.72-1.78-9.43-2.94-12.9-2-4.19,1.1-7.69,3.1-9.85,6.85a24.57,24.57,0,0,0-3,12.47,7.38,7.38,0,0,0,.81,3.83c.84,1.4,2.49,2.3,2.38,4.2a2.65,2.65,0,0,0,.61,1.92c1.12,1.24,2.54.12,3.21-1,1.42-2.41,1.63-5.33,1.8-8.13a18.21,18.21,0,0,0-.27-5.94c-.29-1-.76-2-1-3.09a3.76,3.76,0,0,1,.51-3.11,4.07,4.07,0,0,1,.51-.5A6.49,6.49,0,0,1,85,122c3.49,1.31,9.46,3.28,11,2.12a9.75,9.75,0,0,0,2.85-2.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.17,114.78a13.7,13.7,0,0,1,10.53.79,7.15,7.15,0,0,1,3.68,4.22,4.09,4.09,0,0,1-2.14,4.8l-.13.07c-2.68.85-4.4.46-7-.52-2.21-.81-4.17-2.23-6.4-3a12.74,12.74,0,0,0-7.41-.36A20.69,20.69,0,0,1,83.17,114.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.75,190.13l1.38,4.61,26.26-11.37,5.68,8.72S108.45,207.4,102,212.28s-13.93,3.18-18.28-2.53c-4.46-5.87-6.18-14.28-6.18-14.28Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.34,200.48c.13,0,.45-1.38,1.23-2.95s1.69-2.68,1.59-2.77a7.91,7.91,0,0,0-2.82,5.72Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.31,185.47l3.47-2.4c1.84-5.48,5.27-15.42,6.29-15.12s1.58,1.3,1.26,3.42c-.77,5.06.49,7.29,3.44,6.62,1-.23,9.86-1.64,9.86-1.64s2.44,1.39,0,3.78c0,0,1.19,3.12-2.07,3.87,0,0-.4,3.54-2.85,3.68a63.47,63.47,0,0,1-8.1,3.49l-4.4,2.64Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.92,182.08c0,.17,1.76-.21,3.76-.91.73-.24,1.4-.46,2-.6l-.07-.39-.34.07.08.36a4.24,4.24,0,0,0,1.36-.53,4,4,0,0,0-1.45.18l.07.35.34,0-.07-.39a14.3,14.3,0,0,0-2,.54A30.21,30.21,0,0,0,136.92,182.08Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.26,186.07a7.13,7.13,0,0,0,2.78-.74,6.9,6.9,0,0,0,2.54-1.36,13,13,0,0,0-2.71.93A12.05,12.05,0,0,0,136.26,186.07Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.54 188.02 174.09 229.25 160.31 220.98 148.13 231.91 151.88 188.52 166.54 188.02",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.88,194.19s0,.09,0,.27,0,.46.06.78c0,.71.13,1.68.23,2.86.19,2.41.45,5.75.65,9.45s.32,7.06.38,9.49c0,1.2.05,2.18.07,2.89,0,.32,0,.58,0,.78a.94.94,0,0,0,0,.27.82.82,0,0,0,0-.28c0-.2,0-.47,0-.79,0-.68,0-1.67,0-2.9,0-2.44-.08-5.81-.28-9.51s-.5-7-.75-9.44c-.13-1.2-.24-2.17-.33-2.84-.05-.31-.09-.57-.11-.77S158.89,194.18,158.88,194.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "167.67 189.15 186.37 226.66 192.42 211.79 208.73 213.22 179.7 180.75 167.67 189.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.5,189.49s.07.07.17.21l.42.66,1.53,2.43c1.29,2.05,3.09,4.87,5.15,8s4,5.84,5.39,7.82l1.68,2.35.45.64c.1.15.14.23.13.24a1.69,1.69,0,0,1-.19-.21l-.5-.61c-.43-.53-1-1.32-1.76-2.3-1.47-1.95-3.42-4.7-5.48-7.78s-3.83-5.92-5.07-8c-.62-1-1.11-1.89-1.44-2.47l-.37-.69A.92.92,0,0,1,177.5,189.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M175.8,205.47s3.49.2,5-1.76,1.77-3.27,2.82-4.11,3.66.05,6.22-1.32,2.73-3.11,2.73-3.11L186.18,188l-13.73,10.76Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150.34,206.55s2.81,2.07,5.17,1.26,3.26-1.77,4.6-1.9,3,2,5.93,2.29,4-1.11,4-1.11l-1.73-9.48L150.86,199Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M146.31,134.58l-.07,0a3.21,3.21,0,0,1,.18.34C146.38,134.78,146.35,134.68,146.31,134.58Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.16,174.79c-1.37-.3-3-.67-4.84-1.09-2.32-.55-4.42-1.06-5.94-1.45-1.07-.28-1.85-.5-2.2-.62-.13.46-.27.92-.42,1.37a22.81,22.81,0,0,1-2.34,4.88c-.27.43-.55.84-.85,1.25a22.37,22.37,0,0,1-8.37,6.92l-.41.19a2.27,2.27,0,0,1,1,.52l.09.11a4.86,4.86,0,0,1,1.07,2.18c.25.92.52,1.92.8,3,.37,1.39.7,2.7,1,3.82l.38,1.59a12.31,12.31,0,0,1,.45,2.27,12.93,12.93,0,0,1-.73-2.2c-.4-1.37-.92-3.27-1.48-5.38-.27-1.05-.52-2.05-.76-3a4.66,4.66,0,0,0-1-2.17,2.13,2.13,0,0,0-1.17-.59l-.44.19-.72.28a22.39,22.39,0,0,1-7,1.39c.08,0,.16.1.27.17l.13.1a3.58,3.58,0,0,1,1,1.25,4.89,4.89,0,0,1,.19.46,6.89,6.89,0,0,1,.35,2.07c0,1-.05,2-.12,3.11a53.2,53.2,0,0,1-.71,5.61c-.16.84-.3,1.48-.4,1.87a4.06,4.06,0,0,1,.85-.13c2.36,0,4.68,2.47,6.74,1.33l.19-.12c1.37-.93,1.59-3.17,3.11-3.9a3.14,3.14,0,0,1,2.2-.07,10.5,10.5,0,0,0,3.23.69c1.58-.12,2.55-1.31,3.42-2.73a20.42,20.42,0,0,1,2.55-3.79,4.1,4.1,0,0,1,1.5-1c1.31-.49,3-.28,4.26-.62a2.37,2.37,0,0,0,1.54-1.08c.88-1.53-.5-3.4-.7-5.14l-.49-.35c-1.2-.88-2.85-2.13-4.66-3.52l-2.53-2a8.88,8.88,0,0,0-2.11-1.45,1.47,1.47,0,0,0-1.54.26c-.29.27-.29.53-.34.52a.73.73,0,0,1,.22-.63,1.63,1.63,0,0,1,1.59-.47l.16,0a8.35,8.35,0,0,1,2.25,1.43l2.55,2,.09.06c1.77,1.37,3.36,2.62,4.5,3.55l.29.23s0-.09,0-.13A2.41,2.41,0,0,1,189,185c.86-2.21,4.58-1.93,5.58-4.08a2.23,2.23,0,0,0,.19-.67c.23-1.42-.62-3-.26-4.46a3,3,0,0,1,.21-.55,1.17,1.17,0,0,1,.05-.11l-.5-.1Zm-19,18.11a22.45,22.45,0,0,1-1.8-4.05,8.16,8.16,0,0,1,1.8,4.05Zm6.69-.74a8.67,8.67,0,0,1,1,1.65,10.19,10.19,0,0,1-1.27-1.47l-2.92-3.66L174.72,185c-.42-.52-.74-.93-.93-1.2s-.24-.35-.22-.37a9.18,9.18,0,0,1,1.37,1.38c.81.89,1.89,2.14,3,3.57l.92,1.16C179.64,190.56,180.3,191.45,180.8,192.16Zm4.19-14a10,10,0,0,1-2.65-2.21,28,28,0,0,1,2.88,1.87,27.4,27.4,0,0,1,2.87,1.87A9.88,9.88,0,0,1,185,178.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.1,159.12a2.61,2.61,0,0,0-.14-1.06c-.67-1.76-3.32-2.23-3.9-4v0l-1.68.55-3.08,1-5,1.63a11.37,11.37,0,0,1-2.12.59,8.88,8.88,0,0,1,1.58-.69l.44-.17c1.27-.48,3-1.11,5-1.75s3.54-1.1,4.82-1.46c-.26-1.5,1.16-2.89,1.11-4.43a3.07,3.07,0,0,0-1-2,6.5,6.5,0,0,0-1.45-1.06,10.73,10.73,0,0,1-3.42-2.28,4.88,4.88,0,0,1-.65-1.13c-.66-1.51-.86-3.31-2.16-4.28a3.63,3.63,0,0,0-1.11-.52c-1.61-.47-3.58-.11-5-1.08h0c-2.12-1.49-1.71-5.23-4-6.46a3.13,3.13,0,0,0-.32-.15,3.53,3.53,0,0,0-1.48-.21h0c-1.4.07-2.91.71-4.32.73a3.56,3.56,0,0,1-1.44-.25c-1.29-.55-2.12-2-3.51-2.28a2.68,2.68,0,0,0-1.29.1c-1.38.44-2.64,1.74-4.15,1.87a8.26,8.26,0,0,1-1.07.05c.09,1.31.18,3.33.25,5.6a60.12,60.12,0,0,1,0,7.14,63.67,63.67,0,0,1-.42-7.13c-.07-2.28-.1-4.31-.1-5.62l-.2,0a3.75,3.75,0,0,1-1.84-.78,4.44,4.44,0,0,0-4.34-.44,3.34,3.34,0,0,0-1.13.9c-.87,1.09-1.12,4.36-1.83,4.66a1,1,0,0,1-.8-.07c0,.1.07.2.11.31.41.87,1.21,2.79,2.1,5.05s1.51,4,1.82,5c.51-.19,1-.37,1.52-.53a22.49,22.49,0,0,1,4.88-.94c.44,0,.86-.06,1.29-.07a22.34,22.34,0,0,1,5.61.6l.08,0,0-.19h0a2.48,2.48,0,0,1,.16-.9c.17-.51.39-1.12.62-1.78.32-.9.68-1.89,1.07-3,.69-1.84,1.33-3.51,1.81-4.7a10.26,10.26,0,0,1,.86-1.9,11.53,11.53,0,0,1-.59,2c-.41,1.22-1,2.9-1.69,4.74s-1.33,3.51-1.81,4.7a1.61,1.61,0,0,0-.16,1.05l.55.15a22.53,22.53,0,0,1,6.48,3c.2.13.38.26.57.4a2.31,2.31,0,0,1-.15-.74,2,2,0,0,1,.07-.59,4.16,4.16,0,0,1,.57-1.36c.41-.64.89-1.3,1.4-2,1-1.39,2-2.6,2.77-3.45.51-.58.9-1,1.11-1.18s.16-.14.18-.13a9.17,9.17,0,0,1-1.07,1.49c-.69.9-1.64,2.13-2.66,3.51s-2.07,2.62-2.08,3.71a2.13,2.13,0,0,0,.2,1c.17.12.33.25.49.38a22.45,22.45,0,0,1,3.85,3.88,21.93,21.93,0,0,1,1.38,2,23.46,23.46,0,0,1,1.65,3.24l.24.63c.23.61.43,1.22.6,1.84a22.1,22.1,0,0,1,.8,4.79,21.18,21.18,0,0,1,0,2.39,22.16,22.16,0,0,1-.68,4.45,1,1,0,0,1,0,.14c.35.05,1,.18,2,.37l.25.06c1.53.31,3.64.78,6,1.33s4.42,1,5.93,1.44l.58.15c.49-.81,1.25-1.5,1.83-2.27a3.42,3.42,0,0,0,.71-1.56c.26-2-1.77-3.4-2.69-5.15-1.37-.09-3.45-.28-5.79-.52-1.9-.2-3.63-.4-4.94-.57a12.29,12.29,0,0,1-2.45-.41A68.11,68.11,0,0,1,189,165c1.82.19,3.48.38,4.77.54l.83.11a1,1,0,0,1,0-.1,3.23,3.23,0,0,1-.26-1.07C194.22,162.59,196,160.86,196.1,159.12ZM159.2,138a21,21,0,0,1,1.09-3.43,12.94,12.94,0,0,1-.7,3.55,12.83,12.83,0,0,1-1.27,3.38A20.76,20.76,0,0,1,159.2,138Zm9.7.84a11.15,11.15,0,0,1-2.26,2.62,22,22,0,0,1,1.92-2.85,23.15,23.15,0,0,1,2-2.79A11,11,0,0,1,168.9,138.87Zm7.53,4.37a6.61,6.61,0,0,1,1.88-1.56,8.59,8.59,0,0,1-1.58,1.84,8.48,8.48,0,0,1-1.79,1.65A6.27,6.27,0,0,1,176.43,143.24Zm.3,8.35a.08.08,0,0,1,0,0,11.34,11.34,0,0,1,1.16-1.23c.75-.74,1.81-1.73,3-2.82s2.28-2.05,3.09-2.74a7,7,0,0,1,1.36-1s-.13.2-.41.5l-.75.75c-.76.74-1.82,1.75-3,2.83s-2.28,2.06-3.09,2.74A6.9,6.9,0,0,1,176.73,151.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.68,195.37c.07-1.09.15-2.14.15-3.07a6.17,6.17,0,0,0-.42-2.42,3.94,3.94,0,0,0-.89-1.31,3.74,3.74,0,0,0-.4-.33,21.94,21.94,0,0,1-4.59-.35h-.09c-.05.26-.18.76-.38,1.41a1.39,1.39,0,0,1-.06.19c-.3,1-.73,2.26-1.26,3.66s-1.12,2.81-1.55,3.76a7.15,7.15,0,0,1-.79,1.49s0-.17.1-.43c.26-.81,1-2.72,1.86-5,.92-2.43,1.67-4.5,2-5.13-.6-.12-1.2-.26-1.79-.42a25.61,25.61,0,0,1-1.19,2.28,11.72,11.72,0,0,1-1.65,2.47,10.77,10.77,0,0,1,1.29-2.67c.42-.73.82-1.37,1.12-1.82l.23-.32a22.11,22.11,0,0,1-5.22-2.24c-.37-.21-.73-.44-1.09-.68a22.15,22.15,0,0,1-4.27-3.72c-.29-.32-.57-.65-.84-1a22.15,22.15,0,0,1-2.85-4.69c-.11-.24-.22-.48-.32-.72s-.27-.69-.39-1a22.85,22.85,0,0,1-1.16-5.06c0-.19,0-.37,0-.56a1.78,1.78,0,0,1-.73.51l-.65.16a23.19,23.19,0,0,1-4.86.58,44.71,44.71,0,0,1-5.52-.26c-1-.11-1.69-.2-2-.27-.15,0-.24,0-.24-.07a12.64,12.64,0,0,1,2.29.05l1.8.08c1.1.05,2.35.09,3.69.06l1.12,0a24.3,24.3,0,0,0,4.3-.56,1.5,1.5,0,0,0,.73-.45.46.46,0,0,0,.07-.14c0-.49-.05-1-.05-1.46-.8-.06-2-.19-3.46-.38a24.15,24.15,0,0,1-4.35-.78,22.79,22.79,0,0,1,4.4.37l1.47.21,1.94.32a22.47,22.47,0,0,1,.57-4.78l-.4-.07a39.18,39.18,0,0,1-4.51-1.19,37.67,37.67,0,0,1-4.34-1.7l-.07,0a7.47,7.47,0,0,1-1.63-.89,10.47,10.47,0,0,1,1.81.66c1.11.43,2.64,1,4.36,1.57s3.3,1,4.45,1.29l.39.1c.11-.45.23-.9.37-1.34v0l-.07,0c-.58-.3-1.32-.72-2.11-1.22a13.14,13.14,0,0,1-2.92-2.16,7.48,7.48,0,0,1,1.66.9l1.47.91,2.07,1.32a22.7,22.7,0,0,1,2.42-5.13l.18-.29a7.61,7.61,0,0,1-1.59-.65l-1-.5c-.79-.4-1.69-.87-2.65-1.41-1.42-.79-2.67-1.55-3.55-2.13a7.74,7.74,0,0,1-1.39-1s.31.1.78.35c.91.49,2.51,1.41,4.36,2.44,2.78,1.56,5.06,2.78,5.06,2.91.25-.37.5-.73.76-1.08a22.87,22.87,0,0,1,3.05-3.33l-.34-.43c-.69-.87-1.6-2.11-2.53-3.52s-1.7-2.74-2.23-3.71a13.63,13.63,0,0,1-.75-1.54c0-.05,0-.08,0-.09a8.22,8.22,0,0,1,1,1.48c.59.94,1.4,2.23,2.33,3.63.8,1.23,1.55,2.33,2.15,3.2.09.12.18.26.26.38l.3.44.1-.08c.34-.3.68-.58,1-.85a19.79,19.79,0,0,1-1.36-2.27,12,12,0,0,1-1.26-2.36,6.76,6.76,0,0,1,1.62,2.16c.26.46.48.9.65,1.28.09.2.17.38.23.54a3.59,3.59,0,0,1,.18.6l.05,0a22.28,22.28,0,0,1,4.86-2.77l.12-.05.16-.07c-.37-.81-1-2.32-1.71-4.11-.11-.26-.21-.52-.32-.79-1.08-2.78-1.91-5.11-2-5.6-1.14-.59-2.66-2.2-4.31-1.77-1.37.37-2,.82-2.3,1.56a27.31,27.31,0,0,0-.79,3.86,2.15,2.15,0,0,1-1.16,1.45,4,4,0,0,1-3.08.23c-1.65-.59-3.63.39-4.93,1.72a6.84,6.84,0,0,0-.61.72c-.91,1.25-.67,3-.8,4.54a4.22,4.22,0,0,1-.72,2.23,11.06,11.06,0,0,1-2.88,2.05,2.9,2.9,0,0,0-1.23,1.51c-.41,1.32.52,2.74.61,4.07a2.4,2.4,0,0,1-.15,1.06c-.67,1.6-3.09,1.73-3.93,3.25a2.41,2.41,0,0,0-.2,1.78c.33,1.46,1.57,3,1.73,4.6a3.94,3.94,0,0,1,0,1c-.19,1.16-.78,2.28-1,3.46a3.6,3.6,0,0,0,.21,2,1.86,1.86,0,0,0,1.88,1.41l-.37-.61c1.38,0,2.35,1.49,2.49,2.86a9.63,9.63,0,0,1-.24,2.67c-.09.48-.18,1-.25,1.44a4.27,4.27,0,0,0,1.07,3.84l.1.07c1.14.86,2.84.75,4,1.67a3.71,3.71,0,0,1,1.15,2.33c.37,2.27-.18,5.09,1.76,6.15a2.33,2.33,0,0,0,.65.24c1.93.45,4.38-1.09,6,.17a2.29,2.29,0,0,1,.49.54c.68,1,.82,2.39,1.73,3.2s2.06.7,3.28.43c1.62-.35,3.34-1,4.74-.26a2.68,2.68,0,0,1,.58.42c1.49,1.34,1.72,4.1,3.62,4.89a2.46,2.46,0,0,0,1.08.2c1.85-.05,3.63-2,5.61-2.56,0-.39.14-1.06.25-1.95C160.28,199.53,160.52,197.56,160.68,195.37ZM138,150.91a7.59,7.59,0,0,1-1.87-2.17,14.3,14.3,0,0,1,2.15,1.87,15.1,15.1,0,0,1,2.05,2A7.68,7.68,0,0,1,138,150.91Zm-.8,23.36a9,9,0,0,1-2.56.77,9.13,9.13,0,0,1-2.65.37,8.51,8.51,0,0,1,2.56-.77A9.06,9.06,0,0,1,137.23,174.27Zm-12.44,5.59a9.61,9.61,0,0,1,1.84-.75c1.15-.42,2.74-1,4.49-1.68s3.32-1.31,4.45-1.77a10.36,10.36,0,0,1,1.88-.68,9.24,9.24,0,0,1-1.76,1c-.73.35-1.67.76-2.71,1.2l-1.71.69c-1.75.67-3.37,1.21-4.55,1.56-.53.16-1,.29-1.3.37A1.75,1.75,0,0,1,124.79,179.86Zm5.86,9.83a12.07,12.07,0,0,1,1.59-1.39l1.39-1.12,2.6-2,2.24-1.69c.68-.52,1.32-1,1.79-1.39a4.3,4.3,0,0,0,1.15-1.68,1.09,1.09,0,0,1-.08.57,3,3,0,0,1-.39.74,4.74,4.74,0,0,1-.48.58,19.43,19.43,0,0,1-1.76,1.48l-2.22,1.72c-1.57,1.21-3,2.28-4.07,3.05A9.74,9.74,0,0,1,130.65,189.69Zm10.48,5a10.59,10.59,0,0,1-1.25,1.56,8.8,8.8,0,0,1,1-1.73l1.39-2.09c.41-.6.84-1.23,1.31-1.9,1.06-1.54,2.1-2.93,2.76-3.92a1.33,1.33,0,0,0,.21-.72,1,1,0,0,0-.21-.51c-.21-.24-.43-.21-.43-.25s.23-.12.54.14a1,1,0,0,1,.33.6V186a1.52,1.52,0,0,1-.18.73c-.64,1.1-1.62,2.47-2.68,4S141.87,193.68,141.13,194.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.31,173.28a19.67,19.67,0,1,0,10.74-25.66A19.67,19.67,0,0,0,140.31,173.28Z",
    style: {
      fill: "#F39500"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.09,150.54c.81-.68,1.9-1.65,3.09-2.74s2.25-2.09,3-2.83l.75-.75c.28-.3.43-.48.41-.5a7,7,0,0,0-1.36,1c-.81.69-1.9,1.65-3.09,2.74s-2.25,2.08-3,2.82a11.34,11.34,0,0,0-1.16,1.23.08.08,0,0,0,0,0A6.9,6.9,0,0,0,178.09,150.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.16,157l-.44.17a8.88,8.88,0,0,0-1.58.69,11.37,11.37,0,0,0,2.12-.59l5-1.63,3.08-1,1.68-.55a1.52,1.52,0,0,1-.06-.2.31.31,0,0,1,0-.1c-1.28.36-3,.86-4.82,1.46S183.43,156.5,182.16,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,165a63.73,63.73,0,0,0-7.44-.56,13.93,13.93,0,0,0,2.45.4c1.31.17,3,.37,4.94.57,2.34.24,4.42.43,5.79.52a2.44,2.44,0,0,1-.14-.28l-.83-.11C192.51,165.36,190.85,165.17,189,165Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.41,173.3c-2.32-.55-4.43-1-6-1.33l-.25-.06c-1-.19-1.65-.32-2-.37a1,1,0,0,0,0-.14,22.16,22.16,0,0,0,.68-4.45,21.18,21.18,0,0,0,0-2.39,22.1,22.1,0,0,0-.8-4.79c-.17-.62-.37-1.23-.6-1.84l-.24-.63a23.46,23.46,0,0,0-1.65-3.24,21.93,21.93,0,0,0-1.38-2,22.45,22.45,0,0,0-3.85-3.88c-.16-.13-.32-.26-.49-.38a2.13,2.13,0,0,1-.2-1c0-1.09,1.09-2.31,2.08-3.71s2-2.61,2.66-3.51a9.17,9.17,0,0,0,1.07-1.49s-.08,0-.18.13-.6.6-1.11,1.18c-.75.85-1.74,2.06-2.77,3.45-.51.7-1,1.36-1.4,2a4.16,4.16,0,0,0-.57,1.36,2,2,0,0,0-.07.59,2.31,2.31,0,0,0,.15.74c-.19-.14-.37-.27-.57-.4a22.53,22.53,0,0,0-6.48-3l-.55-.15a1.61,1.61,0,0,1,.16-1.05c.48-1.19,1.13-2.86,1.81-4.7s1.28-3.52,1.69-4.74a11.53,11.53,0,0,0,.59-2,10.26,10.26,0,0,0-.86,1.9c-.48,1.19-1.12,2.86-1.81,4.7-.39,1.07-.75,2.06-1.07,3-.23.66-.45,1.27-.62,1.78a2.48,2.48,0,0,0-.16.9h0l0,.19-.08,0a22.34,22.34,0,0,0-5.61-.6c-.43,0-.85,0-1.29.07a22.49,22.49,0,0,0-4.88.94c-.51.16-1,.34-1.52.53-.31-1-1-2.84-1.82-5s-1.69-4.18-2.1-5.05a3.21,3.21,0,0,0-.18-.34l-.11-.06c.09.49.92,2.82,2,5.6.11.27.21.53.32.79.7,1.79,1.34,3.3,1.71,4.11l-.16.07-.12.05a22.28,22.28,0,0,0-4.86,2.77l-.05,0a3.59,3.59,0,0,0-.18-.6c-.06-.16-.14-.34-.23-.54-.17-.38-.39-.82-.65-1.28a6.76,6.76,0,0,0-1.62-2.16,12,12,0,0,0,1.26,2.36,19.79,19.79,0,0,0,1.36,2.27c-.36.27-.7.55-1,.85l-.1.08-.3-.44c-.08-.12-.17-.26-.26-.38-.6-.87-1.35-2-2.15-3.2-.93-1.4-1.74-2.69-2.33-3.63a8.22,8.22,0,0,0-1-1.48s0,0,0,.09a13.63,13.63,0,0,0,.75,1.54c.53,1,1.31,2.3,2.23,3.71s1.84,2.65,2.53,3.52l.34.43a22.87,22.87,0,0,0-3.05,3.33c-.26.35-.51.71-.76,1.08,0-.13-2.29-1.35-5.06-2.91-1.85-1-3.45-1.95-4.36-2.44-.47-.25-.76-.39-.78-.35a7.74,7.74,0,0,0,1.39,1c.88.58,2.13,1.34,3.55,2.13,1,.54,1.86,1,2.65,1.41l1,.5a7.61,7.61,0,0,0,1.59.65l-.18.29a22.7,22.7,0,0,0-2.42,5.13l-2.07-1.32-1.47-.91a7.48,7.48,0,0,0-1.66-.9,13.14,13.14,0,0,0,2.92,2.16c.79.5,1.53.92,2.11,1.22l.07,0v0c-.14.44-.26.89-.37,1.34l-.39-.1c-1.15-.3-2.73-.73-4.45-1.29s-3.25-1.14-4.36-1.57a10.47,10.47,0,0,0-1.81-.66,7.47,7.47,0,0,0,1.63.89l.07,0a37.67,37.67,0,0,0,4.34,1.7,39.18,39.18,0,0,0,4.51,1.19l.4.07a22.47,22.47,0,0,0-.57,4.78l-1.94-.32-1.47-.21a22.83,22.83,0,0,0-4.4-.37,24.15,24.15,0,0,0,4.35.78c1.41.19,2.66.32,3.46.38,0,.49,0,1,.05,1.46a.46.46,0,0,1-.07.14,1.5,1.5,0,0,1-.73.45,24.3,24.3,0,0,1-4.3.56l-1.12,0c-1.34,0-2.59,0-3.69-.06l-1.8-.08a12.64,12.64,0,0,0-2.29-.05s.09,0,.24.07c.34.07,1,.16,2,.27a44.71,44.71,0,0,0,5.52.26,23.19,23.19,0,0,0,4.86-.58l.65-.16a1.78,1.78,0,0,0,.73-.51c0,.19,0,.37,0,.56a22.72,22.72,0,0,0,1.16,5.06c.12.35.25.69.39,1s.21.48.32.72a22.15,22.15,0,0,0,2.85,4.69c.27.35.55.68.84,1a22.15,22.15,0,0,0,4.27,3.72c.36.24.72.47,1.09.68a22.11,22.11,0,0,0,5.22,2.24l-.23.32c-.3.45-.7,1.09-1.12,1.82a10.77,10.77,0,0,0-1.29,2.67,11.72,11.72,0,0,0,1.65-2.47,25.61,25.61,0,0,0,1.19-2.28c.59.16,1.19.3,1.79.42-.3.63-1.05,2.7-2,5.13-.85,2.25-1.6,4.16-1.86,5-.09.26-.13.42-.1.43a7.15,7.15,0,0,0,.79-1.49c.43-1,1-2.27,1.55-3.76s1-2.68,1.26-3.66a1.39,1.39,0,0,0,.06-.19c.2-.65.33-1.15.38-1.41h.09a21.94,21.94,0,0,0,4.59.35,3.74,3.74,0,0,1,.4.33,3.94,3.94,0,0,1,.89,1.31,6.17,6.17,0,0,1,.42,2.42c0,.93-.08,2-.15,3.07-.16,2.19-.4,4.16-.59,5.59-.11.89-.21,1.56-.25,1.95l.14,0c.1-.38.24-1,.4-1.87a53.2,53.2,0,0,0,.71-5.61c.07-1.1.14-2.14.12-3.11a6.89,6.89,0,0,0-.35-2.07,4.89,4.89,0,0,0-.19-.46,3.58,3.58,0,0,0-1-1.25l-.13-.1c-.11-.07-.19-.13-.27-.17a22.39,22.39,0,0,0,7-1.39l.72-.28.44-.19a2.13,2.13,0,0,1,1.17.59,4.66,4.66,0,0,1,1,2.17c.24.93.49,1.93.76,3,.56,2.11,1.08,4,1.48,5.38a12.93,12.93,0,0,0,.73,2.2,12.31,12.31,0,0,0-.45-2.27l-.38-1.59c-.28-1.13-.61-2.43-1-3.82-.28-1.05-.55-2.05-.8-3a4.86,4.86,0,0,0-1.07-2.18l-.09-.11a2.27,2.27,0,0,0-1-.52l.41-.19a22.37,22.37,0,0,0,8.37-6.92c.3-.41.58-.82.85-1.24a23.12,23.12,0,0,0,2.34-4.89c.15-.45.29-.91.42-1.37.35.12,1.13.34,2.2.62,1.52.39,3.62.9,5.94,1.45,1.8.42,3.47.79,4.84,1.09l1.12.24.5.1c0-.08.09-.16.14-.24l-.58-.15C192.83,174.35,190.73,173.84,188.41,173.3ZM166,184a19.67,19.67,0,1,1,10.74-25.67A19.67,19.67,0,0,1,166,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.09,179.72a27.4,27.4,0,0,0-2.87-1.87,28,28,0,0,0-2.88-1.87,10,10,0,0,0,2.65,2.21A9.88,9.88,0,0,0,188.09,179.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.06,182.18l-.09-.06-2.55-2a8.35,8.35,0,0,0-2.25-1.43l-.16,0a1.63,1.63,0,0,0-1.59.47.73.73,0,0,0-.22.63c.05,0,.05-.25.34-.52a1.47,1.47,0,0,1,1.54-.26,8.88,8.88,0,0,1,2.11,1.45l2.53,2c1.81,1.39,3.46,2.64,4.66,3.52l.49.35a2.06,2.06,0,0,1,0-.35l-.29-.23C187.42,184.8,185.83,183.55,184.06,182.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.65,188.68l2.92,3.66a10.19,10.19,0,0,0,1.27,1.47,8.67,8.67,0,0,0-1-1.65c-.5-.71-1.16-1.6-1.91-2.58l-.92-1.16c-1.14-1.42-2.22-2.68-3-3.57a9.18,9.18,0,0,0-1.37-1.38s.06.15.22.37.51.68.93,1.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.31,188.85a22.45,22.45,0,0,0,1.8,4.05,8.16,8.16,0,0,0-1.8-4.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.47,185.25c-.31-.26-.56-.15-.54-.14s.22,0,.43.25a1,1,0,0,1,.21.51,1.33,1.33,0,0,1-.21.72c-.66,1-1.7,2.38-2.76,3.92-.47.67-.9,1.3-1.31,1.9l-1.39,2.09a8.8,8.8,0,0,0-1,1.73,10.59,10.59,0,0,0,1.25-1.56c.74-1,1.73-2.38,2.81-3.92s2-2.93,2.68-4a1.52,1.52,0,0,0,.18-.73v-.14A1,1,0,0,0,146.47,185.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.33,181a1.09,1.09,0,0,0,.08-.57,4.3,4.3,0,0,1-1.15,1.68c-.47.43-1.11.87-1.79,1.39l-2.24,1.69-2.6,2-1.39,1.12a12.07,12.07,0,0,0-1.59,1.39,9.74,9.74,0,0,0,1.76-1.16c1.06-.77,2.5-1.84,4.07-3.05l2.22-1.72a19.43,19.43,0,0,0,1.76-1.48,4.74,4.74,0,0,0,.48-.58A3,3,0,0,0,141.33,181Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.45,175a10.36,10.36,0,0,0-1.88.68c-1.13.46-2.7,1.1-4.45,1.77s-3.34,1.26-4.49,1.68a9.61,9.61,0,0,0-1.84.75,1.75,1.75,0,0,0,.63-.11c.33-.08.77-.21,1.3-.37,1.18-.35,2.8-.89,4.55-1.56l1.71-.69c1-.44,2-.85,2.71-1.2A9.24,9.24,0,0,0,137.45,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.67,175a9,9,0,0,0,2.56-.77,9.06,9.06,0,0,0-2.65.37,8.51,8.51,0,0,0-2.56.77A9.13,9.13,0,0,0,134.67,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.36,152.59a15.1,15.1,0,0,0-2.05-2,14.3,14.3,0,0,0-2.15-1.87,7.59,7.59,0,0,0,1.87,2.17A7.68,7.68,0,0,0,140.36,152.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,143.08a60.12,60.12,0,0,0,0-7.14c-.07-2.27-.16-4.29-.25-5.6h-.26c0,1.31,0,3.34.1,5.62A63.67,63.67,0,0,0,157,143.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.59,138.15a12.94,12.94,0,0,0,.7-3.55A21,21,0,0,0,159.2,138a20.76,20.76,0,0,0-.88,3.5A12.83,12.83,0,0,0,159.59,138.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.9,138.87a11,11,0,0,0,1.68-3,23.15,23.15,0,0,0-2,2.79,22,22,0,0,0-1.92,2.85A11.15,11.15,0,0,0,168.9,138.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.43,143.24a6.27,6.27,0,0,0-1.49,1.93,8.48,8.48,0,0,0,1.79-1.65,8.59,8.59,0,0,0,1.58-1.84A6.61,6.61,0,0,0,176.43,143.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M156.59,142.66a2.31,2.31,0,0,0,.15.79c.44,0,.86-.06,1.29-.07a2.72,2.72,0,0,0,.35-.73q1.78-6.18,3.58-12.35a2.34,2.34,0,0,0,0-1.8l-.06-.08c-1.38.44-2.64,1.74-4.15,1.87a8.26,8.26,0,0,1-1.07.05c.09,1.31.18,3.33.25,5.6a60.12,60.12,0,0,1,0,7.14,63.67,63.67,0,0,1-.42-7.13c-.07-2.28-.1-4.31-.1-5.62l-.2,0-.06.12Q156.4,136.55,156.59,142.66ZM159.2,138a21,21,0,0,1,1.09-3.43,12.94,12.94,0,0,1-.7,3.55,12.83,12.83,0,0,1-1.27,3.38A20.76,20.76,0,0,1,159.2,138Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165.54,138.16c.69-1.84,1.33-3.51,1.81-4.7a10.26,10.26,0,0,1,.86-1.9,11.53,11.53,0,0,1-.59,2c-.41,1.22-1,2.9-1.69,4.74s-1.33,3.51-1.81,4.7a1.61,1.61,0,0,0-.16,1.05l.55.15c3.24-4.28,6.83-9.49,9.48-13.87a3.53,3.53,0,0,0-1.48-.21h0c-1.4.07-2.91.71-4.32.73-1.18,3.06-2.6,6.75-3.7,10.27C164.79,140.22,165.15,139.23,165.54,138.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.51,138.12a9.17,9.17,0,0,1-1.07,1.49c-.69.9-1.64,2.13-2.66,3.51s-2.07,2.62-2.08,3.71a2.13,2.13,0,0,0,.2,1c.17.12.33.25.49.38C175.58,146,180,141.27,183.3,138c-1.61-.47-3.58-.11-5-1.08-.31.44-.64.87-1,1.3C177.43,138.16,177.49,138.11,177.51,138.12Zm-.78,5.4a8.48,8.48,0,0,1-1.79,1.65,6.27,6.27,0,0,1,1.49-1.93,6.61,6.61,0,0,1,1.88-1.56A8.59,8.59,0,0,1,176.73,143.52Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.19,145c-.76.74-1.82,1.75-3,2.83s-2.28,2.06-3.09,2.74a6.9,6.9,0,0,1-1.36,1.05.08.08,0,0,1,0,0l-.5.52a21.93,21.93,0,0,1,1.38,2l.55-.22c3.68-1.62,9.56-4.45,13.92-6.54a6.5,6.5,0,0,0-1.45-1.06,10.73,10.73,0,0,1-3.42-2.28,4.88,4.88,0,0,1-.65-1.13l-1.63,1.39Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.29,155.62l-5,1.63a11.37,11.37,0,0,1-2.12.59,8.88,8.88,0,0,1,1.58-.69c-.62.2-1.25.41-1.87.64l-.34.14c.23.61.43,1.22.6,1.84,4.43-.14,10.92-.46,16-.65a2.61,2.61,0,0,0-.14-1.06c-.67-1.76-3.32-2.24-3.9-4l-1.69.53Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184,164.82l-2.45-.22c-.22,0-.45,0-.68,0a21.18,21.18,0,0,1,0,2.39c4.43,1.2,10.72,3.92,15.83,5.67a3.42,3.42,0,0,0,.71-1.56c.26-2-1.77-3.4-2.69-5.15-1.37-.09-3.45-.28-5.79-.52C187.08,165.19,185.35,165,184,164.82Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M188.32,173.7c-2.32-.55-4.42-1.06-5.94-1.45-1.07-.28-1.85-.5-2.2-.62-.13.46-.27.92-.42,1.37a6.88,6.88,0,0,0,1.36.74c3.59,1.61,9.39,4.5,13.66,6.51.23-1.42-.62-3-.26-4.46a3,3,0,0,1,.21-.55l-1.57-.45C191.79,174.49,190.12,174.12,188.32,173.7Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M183.72,182.44l-2.53-2a8.88,8.88,0,0,0-2.11-1.45,1.47,1.47,0,0,0-1.54.26c-.29.27-.29.53-.34.52a.73.73,0,0,1,.22-.63,1.63,1.63,0,0,1,1.59-.47,12,12,0,0,0-1.59-.81c-.27.42-.55.83-.85,1.24A103,103,0,0,0,188,192.53a2.37,2.37,0,0,0,1.54-1.08c.88-1.53-.5-3.4-.7-5.14l-.49-.35C187.18,185.08,185.53,183.83,183.72,182.44Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M180.8,192.16a8.67,8.67,0,0,1,1,1.65,10.19,10.19,0,0,1-1.27-1.47l-2.92-3.66L174.72,185c-.42-.52-.74-.93-.93-1.2l-.43-.42c1.52,4.24,4.16,10,6.36,14.53a20.42,20.42,0,0,1,2.55-3.79c-1-1.49-2.17-3-3.38-4.58C179.64,190.56,180.3,191.45,180.8,192.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.15,197.43a12.31,12.31,0,0,1,.45,2.27,12.93,12.93,0,0,1-.73-2.2c-.4-1.37-.92-3.27-1.48-5.38-.27-1.05-.52-2.05-.76-3a4.66,4.66,0,0,0-1-2.17,2.13,2.13,0,0,0-1.17-.59l-.44.19-.72.28a.47.47,0,0,0-.05.1,4.64,4.64,0,0,0-.18,2c.27,4.28,1.3,10.41,1.69,15,1.37-.93,1.59-3.17,3.11-3.9a3.14,3.14,0,0,1,2.2-.07c-.39-1.28-.84-2.7-1.3-4.15Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M160.68,195.37c.07-1.09.15-2.14.15-3.07a6.17,6.17,0,0,0-.42-2.42,3.94,3.94,0,0,0-.89-1.31,1.32,1.32,0,0,0-.54.77c-1.54,4.31-3.45,11-4.75,16.13,1.85-.05,3.63-2,5.61-2.56,0-.39.14-1.06.25-1.95C160.28,199.53,160.52,197.56,160.68,195.37Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5,198c.26-.81,1-2.72,1.86-5,.92-2.43,1.67-4.5,2-5.13-.6-.12-1.2-.26-1.79-.42a25.61,25.61,0,0,1-1.19,2.28,11.72,11.72,0,0,1-1.65,2.47,10.77,10.77,0,0,1,1.29-2.67c.42-.73.82-1.37,1.12-1.82a11.93,11.93,0,0,0-1.86,2.51l-6,10c1.62-.35,3.34-1,4.74-.26a2.68,2.68,0,0,1,.58.42C149.82,199.62,150.15,198.81,150.5,198Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M143.6,190.51c1.06-1.54,2.1-2.93,2.76-3.92a1.33,1.33,0,0,0,.21-.72,1,1,0,0,0-.21-.51c-.21-.24-.43-.21-.43-.25s.23-.12.54.14a1,1,0,0,1,.33.6V186a1.85,1.85,0,0,0,.32-.85c-.37-.21-.73-.44-1.09-.68a2.89,2.89,0,0,0-.83.48c-3.48,2.63-8.53,7.31-12.48,10.94,1.93.45,4.38-1.09,6,.17a2.29,2.29,0,0,1,.49.54l3.09-4.18C142.7,191.81,143.13,191.18,143.6,190.51Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136.23,185.15l2.24-1.69c.68-.52,1.32-1,1.79-1.39a4.3,4.3,0,0,0,1.15-1.68,1.09,1.09,0,0,1-.08.57,3,3,0,0,1-.39.74l.27-.23a1.93,1.93,0,0,0,.55-.73c-.29-.32-.57-.65-.84-1a3,3,0,0,0-1,.23q-7.34,2.72-14.66,5.52c1.14.86,2.84.75,4,1.67a3.71,3.71,0,0,1,1.15,2.33l3.32-2.31Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.79,179.86a9.61,9.61,0,0,1,1.84-.75c1.15-.42,2.74-1,4.49-1.68s3.32-1.31,4.45-1.77a10.36,10.36,0,0,1,1.88-.68,9.24,9.24,0,0,1-1.76,1c-.73.35-1.67.76-2.71,1.2,1.83-.67,3.56-1.35,5-2l.12-.06c-.11-.24-.22-.48-.32-.72s-.27-.69-.39-1l-.13,0c-5-.74-11.42-.1-16.7.54a1.86,1.86,0,0,0,1.88,1.41l-.37-.61c1.38,0,2.35,1.49,2.49,2.86a9.63,9.63,0,0,1-.24,2.67l1.13-.39A1.75,1.75,0,0,1,124.79,179.86Zm9.79-5.22a9.06,9.06,0,0,1,2.65-.37,9,9,0,0,1-2.56.77,9.13,9.13,0,0,1-2.65.37A8.51,8.51,0,0,1,134.58,174.64Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M122.12,168.32a12.64,12.64,0,0,1,2.29.05l1.8.08c1.58,0,3.22,0,4.81,0a24.3,24.3,0,0,0,4.3-.56,1.5,1.5,0,0,0,.73-.45.46.46,0,0,0,.07-.14c0-.49-.05-1-.05-1.46-.8-.06-2-.19-3.46-.38a24.15,24.15,0,0,1-4.35-.78,22.83,22.83,0,0,1,4.4.37l1.47.21a135.85,135.85,0,0,0-14.48-2.52c.33,1.46,1.57,3,1.73,4.6a3.94,3.94,0,0,1,0,1h1C122.21,168.36,122.12,168.34,122.12,168.32Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.69,156.93a10.47,10.47,0,0,1,1.81.66c1.11.43,2.64,1,4.36,1.57s3.3,1,4.45,1.29l.39.1c.11-.45.23-.9.37-1.34l-.07-.06c-.58-.3-1.32-.72-2.11-1.22a13.14,13.14,0,0,1-2.92-2.16,7.48,7.48,0,0,1,1.66.9,84.6,84.6,0,0,0-9.08-5.59,2.9,2.9,0,0,0-1.23,1.51c-.41,1.32.52,2.74.61,4.07,1,.36,2.18.76,3.39,1.16A7.47,7.47,0,0,1,125.69,156.93Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M134.71,150.56c2.77,1.56,5.06,2.78,5.06,2.91.25-.37.5-.73.76-1.08l-.11-.12c-2.81-2.93-7.56-7.41-10.86-10.73a6.84,6.84,0,0,0-.61.72c-.91,1.25-.67,3-.8,4.54.65.38,1.4.83,2.2,1.32S132.86,149.53,134.71,150.56Zm1.45-1.82a14.3,14.3,0,0,1,2.15,1.87,15.1,15.1,0,0,1,2.05,2,7.68,7.68,0,0,1-2.33-1.68A7.59,7.59,0,0,1,136.16,148.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.72,139.77a8.22,8.22,0,0,1,1,1.48c.59.94,1.4,2.23,2.33,3.63.8,1.23,1.55,2.33,2.15,3.2.23.27.45.52.66.74.34-.3.68-.58,1-.85a19.79,19.79,0,0,1-1.36-2.27,12,12,0,0,1-1.26-2.36,6.76,6.76,0,0,1,1.62,2.16c.26.46.48.9.65,1.28-1.56-3.77-3.46-8.67-5-12.5a27.31,27.31,0,0,0-.79,3.86,2.15,2.15,0,0,1-1.16,1.45c.06.09.11.18.16.27S137.71,139.78,137.72,139.77Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M148.52,139.94c.83,2.14,1.51,4,1.82,5,.51-.19,1-.37,1.52-.53a12.35,12.35,0,0,0-.06-4.69c-.4-2.83-1.21-7.31-1.73-10.61a3.34,3.34,0,0,0-1.13.9c-.87,1.09-1.12,4.36-1.83,4.66a1,1,0,0,1-.8-.07c0,.1.07.2.11.31C146.83,135.76,147.63,137.68,148.52,139.94Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M177.72,160.22a20.1,20.1,0,1,1-25-13.46A20.11,20.11,0,0,1,177.72,160.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.84 169.48 150.71 165.75 157.71 168.75 164.92 155 168.46 156.94 159.12 174.29 148.84 169.48",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.29,164.8a1.66,1.66,0,0,1,.1.43,9,9,0,0,1,.14,1.26,14.36,14.36,0,0,1-.47,4.67A17.47,17.47,0,0,1,172,177.4a16.62,16.62,0,0,1-15.1,6.52,17.85,17.85,0,0,1-6.66-2,14.9,14.9,0,0,1-3.76-2.8,8.71,8.71,0,0,1-.84-1c-.18-.23-.27-.35-.25-.36a19.59,19.59,0,0,0,5,3.8,17.85,17.85,0,0,0,6.53,1.84,16.35,16.35,0,0,0,14.68-6.33,17.74,17.74,0,0,0,3.09-6.05A19.16,19.16,0,0,0,175.29,164.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.19,167.34a1.5,1.5,0,0,1-.1-.44,8.84,8.84,0,0,1-.15-1.28,14.59,14.59,0,0,1,.52-4.71,17.87,17.87,0,0,1,3.18-6.27,18.33,18.33,0,0,1,3-3,17.56,17.56,0,0,1,3.85-2.31,18.23,18.23,0,0,1,15.25.66,14.84,14.84,0,0,1,3.83,2.79,9,9,0,0,1,.85,1c.19.23.28.36.26.37a19.42,19.42,0,0,0-5.1-3.8,18.29,18.29,0,0,0-6.63-1.79,17.78,17.78,0,0,0-8.26,1.29,18.05,18.05,0,0,0-3.74,2.23,18.56,18.56,0,0,0-2.88,2.86,17.72,17.72,0,0,0-3.2,6.07,15.44,15.44,0,0,0-.67,4.6C141.16,166.72,141.24,167.33,141.19,167.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.76,176.51l8.62,69.83a6.76,6.76,0,0,1-5,7.41l-44.49,7.81a4.36,4.36,0,0,1-5.1-4.29c-.12-9.62-.5-30.43-1.85-43.39-1.49-14.3-1.42-27.68,3.84-34.5a40.36,40.36,0,0,1,10.6-9.85l1.49-5.46s18.69,1.24,22,4.15l2,3.58Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.38,169.53a4.16,4.16,0,0,0,1,.1l2.74.14c2.31.11,5.49.32,9,.64s6.69.71,9,1l2.72.31a4.53,4.53,0,0,0,1,.05,4.52,4.52,0,0,0-1-.24c-.64-.12-1.56-.28-2.71-.46-2.29-.35-5.46-.78-9-1.11s-6.73-.48-9-.51c-1.16,0-2.1,0-2.75,0A3.93,3.93,0,0,0,69.38,169.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M86.28,201.38l4,26.69,5-.85s3.55,15.2,15.4,12.95L103.3,226l-3.68-14.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M119,214.56l-27.45,8s-4.18-15.69-6.19-24.95c-2.2-10.12-.44-15.38,6.22-20.08a11.15,11.15,0,0,1,5.06-2A12,12,0,0,1,109,182.93a108.08,108.08,0,0,1,4.44,12.77C116.11,204.69,119,214.56,119,214.56Z",
    style: {
      fill: "#65AC1E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.34,197.65a1.7,1.7,0,0,0,.07.48c.06.35.15.8.27,1.38.25,1.19.63,2.94,1.15,5.15,1,4.41,2.57,10.65,4.5,18l0,.21.21-.06,17.28-5,10.17-3,.22-.07-.06-.22c-2.71-9.16-5-17.13-6.78-22.77-.91-2.81-1.74-5-2.35-6.52-.31-.75-.56-1.33-.74-1.71a2.42,2.42,0,0,0-.29-.57s.07.21.22.6.38,1,.66,1.73c.57,1.52,1.35,3.74,2.22,6.56,1.71,5.65,3.94,13.65,6.62,22.81l.16-.29-10.18,3-17.27,5.08.27.15c-2-7.33-3.56-13.55-4.66-17.94-.54-2.17-1-3.9-1.27-5.12-.14-.57-.25-1-.34-1.36A4,4,0,0,0,85.34,197.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.18,182.37c.07,0,.61-.78,1.73-1.89A14.79,14.79,0,0,1,94,177.19a14.51,14.51,0,0,1,6-.87c1.56.1,2.51.37,2.53.29a1.8,1.8,0,0,0-.64-.26A11.58,11.58,0,0,0,100,176a13.33,13.33,0,0,0-6.18.76,13.54,13.54,0,0,0-5.18,3.5,11.91,11.91,0,0,0-1.18,1.51A2.05,2.05,0,0,0,87.18,182.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.23,215.47l1.38,4.67,26.26-11.52,5.68,8.84S128.93,233,122.47,237.92s-13.93,3.22-18.28-2.57C99.73,229.41,98,220.88,98,220.88Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.82,226c.13,0,.45-1.4,1.23-3s1.69-2.72,1.59-2.81a6,6,0,0,0-2,2.6A6.07,6.07,0,0,0,114.82,226Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,210.75l3.47-2.43c1.84-5.56,5.27-15.63,6.29-15.33s1.58,1.33,1.26,3.47c-.77,5.13.49,7.38,3.44,6.71,1-.24,8.89-1.16,8.89-1.16s2.47.7,1,3.33c0,0,1.19,3.16-2.07,3.92,0,0-.4,3.58-2.85,3.73a62.52,62.52,0,0,1-8.1,3.53l-4.4,2.68Z",
    style: {
      fill: "#e49384"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.4,207.31c0,.18,1.76-.21,3.76-.92.73-.24,1.4-.47,2-.61l-.07-.39-.34.07.08.36c.85-.26,1.38-.46,1.36-.54a4.3,4.3,0,0,0-1.45.18l.07.37.34-.05-.07-.39a13.19,13.19,0,0,0-2,.55A29.19,29.19,0,0,0,157.4,207.31Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.74,211.35a6.73,6.73,0,0,0,2.78-.74,7,7,0,0,0,2.54-1.38,12.1,12.1,0,0,0-2.71.94A12.36,12.36,0,0,0,156.74,211.35Z",
    style: {
      fill: "#a86b62"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.36,388.44c0,2.08-28.07,88.07-28.07,88.07H80l28-88.07Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.31,
    y: 384.83,
    width: 11.26,
    height: 91.68,
    transform: "translate(307.87 861.34) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.06,
    y: 412.62,
    width: 35.85,
    height: 7.98,
    transform: "translate(207.97 833.21) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.36,
    y: 381.2,
    width: 62.33,
    height: 7.98,
    transform: "translate(257.05 770.38) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.87,
    y: 441.82,
    width: 37.1,
    height: 7.98,
    transform: "translate(186.84 891.61) rotate(180)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97,389.44c0,.13,14.06.23,31.4.23s31.41-.1,31.41-.23-14.06-.24-31.41-.24S97,389.31,97,389.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.08,476.51c.13,0,.24-18.78.24-41.94s-.11-41.94-.24-41.94-.23,18.77-.23,41.94S148,476.51,148.08,476.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.29,476.51c.12.05,6.31-18.89,13.82-42.31s13.5-42.44,13.38-42.49-6.31,18.88-13.82,42.31S91.16,476.46,91.29,476.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82,476.51c.12.05,6.31-18.89,13.82-42.31s13.5-42.44,13.38-42.49S100.71,410.59,93.2,434,79.69,476.46,79.82,476.51Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMyCertificates);
export default __webpack_public_path__ + "static/media/empty-my-certificates.9829c72eb97c3aae3fdf23e15ebc4f45.svg";
export { ForwardRef as ReactComponent };